export var SvgAccessControl = {
  name: 'SvgAccessControl',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M7 6h10v13h-10v-13zM16 13v-2h-1v2h1zM6 4h12c0.552 0 1 0.448 1 1v15c0 0.552-0.448 1-1 1h-12c-0.552 0-1-0.448-1-1v-15c0-0.552 0.448-1 1-1zM6 5v15h12v-15h-12z"
      }
    })]);
  }
};
export var SvgAccessControlDevice = {
  name: 'SvgAccessControlDevice',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M18 20h-4v1h-2v-1h-1v-6h10v6h-1v1h-2v-1zM19 13h-1v-8h-12v15h4v1h-4c-0.552 0-1-0.448-1-1v-15c0-0.552 0.448-1 1-1h12c0.552 0 1 0.448 1 1v8zM17 13h-7v6h-3v-13h10v7zM16 12v-2h-1v2h1zM17 17c0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.552-0.448-1-1-1s-1 0.448-1 1zM13 16v2h1v-2h-1zM15 16v2h1v-2h-1z"
      }
    })]);
  }
};
export var SvgAccessLevel = {
  name: 'SvgAccessLevel',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M15 11.207c-2.308 0.653-4 2.775-4 5.293 0 0.9 0.216 1.75 0.6 2.5h-4.6v-14h10v6.022c-0.165-0.015-0.331-0.022-0.5-0.022s-0.335 0.008-0.5 0.022v-1.022h-1v1.207zM17 16v-2c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v2.5c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.5zM19 11.6c-0.317-0.162-0.651-0.294-1-0.393v-7.207h-12v16h6.257c0.313 0.379 0.677 0.716 1.080 1h-7.337c-0.552 0-1-0.448-1-1v-16c0-0.552 0.448-1 1-1h12c0.552 0 1 0.448 1 1v7.6zM16.5 21c-2.485 0-4.5-2.015-4.5-4.5s2.015-4.5 4.5-4.5c2.485 0 4.5 2.015 4.5 4.5s-2.015 4.5-4.5 4.5z"
      }
    })]);
  }
};
export var SvgAirConditioner = {
  name: 'SvgAirConditioner',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M4 5h16c0.552 0 1 0.448 1 1v6c0 0.552-0.448 1-1 1h-16c-0.552 0-1-0.448-1-1v-6c0-0.552 0.448-1 1-1zM4 10v1h16v-1h-16zM16 7v1h4v-1h-4zM16.293 18h-0.793c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h0.793l-0.646-0.646c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l0.646 0.646v-0.793c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v0.793l0.646-0.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-0.646 0.646h0.793c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-0.793l0.646 0.646c0.195 0.195 0.195 0.512 0 0.707s-0.512 0.195-0.707 0l-0.646-0.646v0.793c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-0.793l-0.646 0.646c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707l0.646-0.646zM6.276 14.053c0.247-0.123 0.547-0.023 0.671 0.224s0.023 0.547-0.224 0.671c-0.503 0.251-0.724 0.583-0.724 1.053 0 0.189 0.098 0.298 0.527 0.584 0.695 0.464 0.973 0.772 0.973 1.416 0 0.863-0.446 1.532-1.276 1.947-0.247 0.123-0.547 0.023-0.671-0.224s-0.023-0.547 0.224-0.671c0.503-0.251 0.724-0.583 0.724-1.053 0-0.189-0.098-0.298-0.527-0.584-0.695-0.464-0.973-0.772-0.973-1.416 0-0.863 0.446-1.532 1.276-1.947zM9.276 14.053c0.247-0.123 0.547-0.023 0.671 0.224s0.023 0.547-0.224 0.671c-0.503 0.251-0.724 0.583-0.724 1.053 0 0.189 0.098 0.298 0.527 0.584 0.695 0.464 0.973 0.772 0.973 1.416 0 0.863-0.446 1.532-1.276 1.947-0.247 0.123-0.547 0.023-0.671-0.224s-0.023-0.547 0.224-0.671c0.503-0.251 0.724-0.583 0.724-1.053 0-0.189-0.098-0.298-0.527-0.584-0.695-0.464-0.973-0.772-0.973-1.416 0-0.863 0.446-1.532 1.276-1.947zM12.276 14.053c0.247-0.123 0.547-0.023 0.671 0.224s0.023 0.547-0.224 0.671c-0.503 0.251-0.724 0.583-0.724 1.053 0 0.189 0.098 0.298 0.527 0.584 0.695 0.464 0.973 0.772 0.973 1.416 0 0.863-0.446 1.532-1.276 1.947-0.247 0.123-0.547 0.023-0.671-0.224s-0.023-0.547 0.224-0.671c0.503-0.251 0.724-0.583 0.724-1.053 0-0.189-0.098-0.298-0.527-0.584-0.695-0.464-0.973-0.772-0.973-1.416 0-0.863 0.446-1.532 1.276-1.947z"
      }
    })]);
  }
};
export var SvgAlarm = {
  name: 'SvgAlarm',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M6 18h12c0.552 0 1 0.448 1 1s-0.448 1-1 1h-12c-0.552 0-1-0.448-1-1s0.448-1 1-1zM9 4h6c1.657 0 3 1.343 3 3v10h-12v-10c0-1.657 1.343-3 3-3zM9 10c-0.552 0-1 0.448-1 1v5h2v-5c0-0.552-0.448-1-1-1z"
      }
    })]);
  }
};
export var SvgAlarmBox = {
  name: 'SvgAlarmBox',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "width": "24px",
        "height": "24px",
        "viewBox": "0 0 24 24",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [h("g", {
      "attrs": {
        "id": "Main",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [h("g", {
      "attrs": {
        "id": "Tree/Main/Alarm_box",
        "fill": "#6F7E91",
        "fill-rule": "nonzero"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M11,7 L11,5 L10,5 L10,7 L9,7 L9,4.5 C9,3.672 9.672,3 10.5,3 L12.5,3 C13.328,3 14,3.672 14,4.5 L14,7 L11,7 Z M6.5,8 L16.5,8 L18.5,11 L16.5,21 L6.5,21 L4.5,11 L6.5,8 Z M9.5,10 C9.224,10 9,10.224 9,10.5 C9,10.776 9.224,11 9.5,11 L13.5,11 C13.776,11 14,10.776 14,10.5 C14,10.224 13.776,10 13.5,10 L9.5,10 Z M9.5,12 C9.224,12 9,12.224 9,12.5 C9,12.776 9.224,13 9.5,13 L13.5,13 C13.776,13 14,12.776 14,12.5 C14,12.224 13.776,12 13.5,12 L9.5,12 Z M11.5,19 C12.881,19 14,17.881 14,16.5 C14,15.119 12.881,14 11.5,14 C10.119,14 9,15.119 9,16.5 C9,17.881 10.119,19 11.5,19 Z M11.5,18 C10.672,18 10,17.328 10,16.5 C10,15.672 10.672,15 11.5,15 C12.328,15 13,15.672 13,16.5 C13,17.328 12.328,18 11.5,18 Z",
        "id": "形状"
      }
    })])])]);
  }
};
export var SvgAlarmInput = {
  name: 'SvgAlarmInput',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M10.759 18c0.003 0.523 0.171 0.896 0.425 1.22 0.093 0.119 0.435 0.416 0.884 0.78h-6.067c-0.552 0-1-0.448-1-1s0.448-1 1-1h4.759zM18 15.807h-0.86c0.142-0.465 0.054-0.924-0.266-1.377-0.479-0.679-1.633-0.838-2.192-0.431s-3.399 2.542-3.499 2.642c-0.038 0.038-0.137 0.154-0.23 0.358h-4.953v-10c0-1.657 1.343-3 3-3h6c1.657 0 3 1.343 3 3v8.807zM9 10c-0.552 0-1 0.448-1 1v5h2v-5c0-0.552-0.448-1-1-1zM19.9 17.009v2h-5l1 1.1c0.2 0.2 0.1 0.5-0.1 0.7s-0.5 0.2-0.7 0c0 0-2.7-2-2.8-2.1-0.2-0.2-0.3-0.4-0.3-0.7 0-0.2 0-0.5 0.2-0.7 0.1-0.1 2.9-2.2 2.9-2.2 0.2-0.2 0.5-0.1 0.7 0.1s0.2 0.5 0 0.7l-0.9 1.1h5z"
      }
    })]);
  }
};
export var SvgAlarmOutput = {
  name: 'SvgAlarmOutput',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M11 18v2h-5c-0.552 0-1-0.448-1-1s0.448-1 1-1h5zM18 14.527c-0.32-0.239-0.578-0.431-0.71-0.527-0.559-0.408-1.713-0.248-2.192 0.431-0.32 0.453-0.408 0.912-0.266 1.377h-3.832v1.193h-5v-10c0-1.657 1.343-3 3-3h6c1.657 0 3 1.343 3 3v7.527zM9 10c-0.552 0-1 0.448-1 1v5h2v-5c0-0.552-0.448-1-1-1zM12 17.009h5l-0.9-1.1c-0.2-0.2-0.2-0.5 0-0.7s0.5-0.3 0.7-0.1c0 0 2.8 2.1 2.9 2.2 0.2 0.2 0.2 0.5 0.2 0.7 0 0.3-0.1 0.5-0.3 0.7-0.1 0.1-2.8 2.1-2.8 2.1-0.2 0.2-0.5 0.2-0.7 0s-0.3-0.5-0.1-0.7l1-1.1h-5v-2z"
      }
    })]);
  }
};
export var SvgAlarmSmallBox = {
  name: 'SvgAlarmSmallBox',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "width": "24px",
        "height": "24px",
        "viewBox": "0 0 24 24",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [h("g", {
      "attrs": {
        "id": "Main",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [h("g", {
      "attrs": {
        "id": "Tree/Main/Alarm_small_box",
        "fill": "#6F7E91",
        "fill-rule": "nonzero"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M6,3 L18,3 C18.552,3 19,3.448 19,4 L19,19 C19,19.552 18.552,20 18,20 L6,20 C5.448,20 5,19.552 5,19 L5,4 C5,3.448 5.448,3 6,3 Z M6.75,5.5 C7.164,5.5 7.5,5.164 7.5,4.75 C7.5,4.336 7.164,4 6.75,4 C6.336,4 6,4.336 6,4.75 C6,5.164 6.336,5.5 6.75,5.5 Z M17.25,5.5 C17.664,5.5 18,5.164 18,4.75 C18,4.336 17.664,4 17.25,4 C16.836,4 16.5,4.336 16.5,4.75 C16.5,5.164 16.836,5.5 17.25,5.5 Z M6.75,19 C7.164,19 7.5,18.664 7.5,18.25 C7.5,17.836 7.164,17.5 6.75,17.5 C6.336,17.5 6,17.836 6,18.25 C6,18.664 6.336,19 6.75,19 Z M17.25,19 C17.664,19 18,18.664 18,18.25 C18,17.836 17.664,17.5 17.25,17.5 C16.836,17.5 16.5,17.836 16.5,18.25 C16.5,18.664 16.836,19 17.25,19 Z M8.5,6 C8.224,6 8,6.224 8,6.5 C8,6.776 8.224,7 8.5,7 L15.5,7 C15.776,7 16,6.776 16,6.5 C16,6.224 15.776,6 15.5,6 L8.5,6 Z M8.5,8 C8.224,8 8,8.224 8,8.5 C8,8.776 8.224,9 8.5,9 L15.5,9 C15.776,9 16,8.776 16,8.5 C16,8.224 15.776,8 15.5,8 L8.5,8 Z M8.5,10 C8.224,10 8,10.224 8,10.5 C8,10.776 8.224,11 8.5,11 L15.5,11 C15.776,11 16,10.776 16,10.5 C16,10.224 15.776,10 15.5,10 L8.5,10 Z M12,18 C13.657,18 15,16.657 15,15 C15,13.343 13.657,12 12,12 C10.343,12 9,13.343 9,15 C9,16.657 10.343,18 12,18 Z M12,17 C10.895,17 10,16.105 10,15 C10,13.895 10.895,13 12,13 C13.105,13 14,13.895 14,15 C14,16.105 13.105,17 12,17 Z",
        "id": "形状"
      }
    })])])]);
  }
};
export var SvgArea = {
  name: 'SvgArea',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M5 21h3v-11h-3v11zM9 5c0-0.552 0.448-1 1-1h8c0.552 0 1 0.448 1 1v16h-10v-16zM11 7v2h2v-2h-2zM11 13h2v-2h-2v2zM11 17h2v-2h-2v2zM15 7v2h2v-2h-2zM15 15v2h2v-2h-2zM15 11v2h2v-2h-2z"
      }
    })]);
  }
};
export var SvgBooth = {
  name: 'SvgBooth',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M19 8.848h-2v10h1v1h1v1h-14v-1h1v-1h1v-10h-2v-1.421c0-0.358 0.191-0.688 0.503-0.866l5.999-3.428c0.309-0.177 0.687-0.177 0.996 0l5.999 3.428c0.312 0.178 0.503 0.508 0.503 0.866v1.421zM14 12.848h2v-4h-2v4zM11 12.848h2v-4h-2v4zM8 12.848h2v-4h-2v4z"
      }
    })]);
  }
};
export var SvgBoxCamera = {
  name: 'SvgBoxCamera',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M7 12h8v-1h-8v-3c0-0.552 0.448-1 1-1h11c0.552 0 1 0.448 1 1v8c0 0.552-0.448 1-1 1h-11c-0.552 0-1-0.448-1-1v-4zM6 11h-2v1h2v3h-3c-0.552 0-1-0.448-1-1v-4c0-0.552 0.448-1 1-1h3v2z"
      }
    })]);
  }
};
export var SvgBoxCameraWithPtz = {
  name: 'SvgBoxCameraWithPtz',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M9.443 10l-2.443 2.443v-2.443h2.443zM15.533 10h0.467v-1h-1.467l-2.045-2.045-2.045 2.045h-3.443v-2.9c0-0.608 0.492-1.1 1.1-1.1h11.8c0.608 0 1.1 0.492 1.1 1.1v7.8c0 0.608-0.492 1.1-1.1 1.1h-0.744l0.689-0.689-4.311-4.311zM6 9h-2v1h2v3h-1.9c-0.608 0-1.1-0.492-1.1-1.1v-3.8c0-0.608 0.492-1.1 1.1-1.1h1.9v2zM15.654 13.242v-1.397l2.505 2.307-2.505 2.307v-1.311h-1.32l-0.934 0.934v1.303h1.369l-2.307 2.505-2.307-2.505h1.119l0.22-0.005v-1.323l-0.886-0.886-0.237-0.001-1.115-0.003v1.293l-2.505-2.307 2.505-2.307v1.414h1.311l0.931-0.931 0.001-0.203 0.003-1.12h-1.347l2.307-2.505 2.307 2.505h-1.36v1.31l0.927 0.927h1.318z"
      }
    })]);
  }
};
export var SvgBranch = {
  name: 'SvgBranch',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M5.5 20h13c0.276 0 0.5 0.224 0.5 0.5v0c0 0.276-0.224 0.5-0.5 0.5h-13c-0.276 0-0.5-0.224-0.5-0.5v0c0-0.276 0.224-0.5 0.5-0.5zM14 20h-8v-16c0-0.552 0.448-1 1-1h6c0.552 0 1 0.448 1 1v5h3c0.552 0 1 0.448 1 1v10h-4zM16 15h-1v2h1v-2zM16 11h-1v2h1v-2zM11 15v2h1v-2h-1zM11 11v2h1v-2h-1zM8 15v2h1v-2h-1zM8 11v2h1v-2h-1zM8 7v2h1v-2h-1zM11 7v2h1v-2h-1z"
      }
    })]);
  }
};
export var SvgCamera = {
  name: 'SvgCamera',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M12.403 8.091c-0.813 0.254-1.403 1.013-1.403 1.909 0 1.105 0.895 2 2 2s2-0.895 2-2c0-0.127-0.012-0.25-0.034-0.37 0.646 0.779 1.034 1.779 1.034 2.87 0 2.485-2.015 4.5-4.5 4.5s-4.5-2.015-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5 0.309 0 0.611 0.031 0.903 0.091zM11.5 21c-4.694 0-8.5-3.806-8.5-8.5s3.806-8.5 8.5-8.5c4.694 0 8.5 3.806 8.5 8.5s-3.806 8.5-8.5 8.5zM11.5 19c3.588 0 6.5-2.916 6.5-6.5s-2.916-6.5-6.5-6.5c-3.584 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5zM8.707 15.121c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"
      }
    })]);
  }
};
export var SvgCameraProbe = {
  name: 'SvgCameraProbe',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M7.102 12.081c0-2.803 2.248-5.099 5.025-5.099s5.024 2.296 5.024 5.099c0.001 0.896-0.234 1.777-0.681 2.553l-0.056 0.086c-0.153 0.305-0.465 0.513-0.826 0.513-0.514 0-0.931-0.42-0.931-0.941-0.001-0.172 0.046-0.34 0.134-0.487l0.1-0.171c0.262-0.475 0.399-1.009 0.399-1.552 0-1.764-1.418-3.238-3.164-3.238s-3.164 1.474-3.164 3.238c-0 0.543 0.137 1.076 0.398 1.552l0.101 0.171c0.088 0.147 0.135 0.316 0.134 0.487 0 0.521-0.417 0.941-0.93 0.941-0.361 0-0.674-0.208-0.826-0.513l-0.056-0.086c-0.432-0.752-0.681-1.623-0.681-2.553zM4.125 12.081c0-4.463 3.584-8.077 8.002-8.077s8.002 3.614 8.002 8.077c0 1.82-0.595 3.499-1.604 4.85l-0.067 0.093c-0.174 0.239-0.452 0.38-0.748 0.38-0.514 0-0.93-0.42-0.93-0.938-0.001-0.208 0.067-0.411 0.193-0.577l0.071-0.097c0.77-1.035 1.224-2.319 1.224-3.711 0-3.424-2.751-6.216-6.141-6.216s-6.141 2.791-6.141 6.216c0 1.392 0.454 2.676 1.224 3.711l0.071 0.097c0.126 0.166 0.194 0.369 0.193 0.577 0 0.517-0.417 0.938-0.93 0.938-0.296 0-0.574-0.141-0.748-0.38l-0.067-0.093c-1.009-1.351-1.604-3.030-1.604-4.85zM11.227 18.147v-4.333c-0.59-0.32-0.99-0.944-0.99-1.662 0-1.044 0.846-1.89 1.89-1.89s1.89 0.846 1.89 1.89c0 0.718-0.4 1.343-0.99 1.662v4.333h2.173c0.788 0 1.427 0.639 1.427 1.427s-0.639 1.427-1.427 1.427h-6.147c-0.788 0-1.427-0.639-1.427-1.427s0.639-1.427 1.427-1.427h2.173z"
      }
    })]);
  }
};
export var SvgCardReader = {
  name: 'SvgCardReader',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M6 3h11c0.552 0 1 0.448 1 1v16c0 0.552-0.448 1-1 1h-11c-0.552 0-1-0.448-1-1v-16c0-0.552 0.448-1 1-1zM9.12 13.441c0.566 0.667 1.396 1.059 2.288 1.059 0.934 0 1.799-0.43 2.363-1.152 0.17-0.217 0.132-0.532-0.085-0.702s-0.532-0.132-0.702 0.085c-0.377 0.482-0.952 0.768-1.576 0.768-0.595 0-1.147-0.261-1.525-0.706-0.179-0.211-0.494-0.236-0.705-0.058s-0.236 0.494-0.058 0.705zM13.771 9.651c-0.565-0.721-1.429-1.151-2.363-1.151-0.893 0-1.723 0.393-2.29 1.061-0.179 0.211-0.152 0.526 0.058 0.705s0.526 0.152 0.705-0.058c0.378-0.446 0.931-0.708 1.527-0.708 0.623 0 1.198 0.286 1.576 0.768 0.17 0.217 0.485 0.256 0.702 0.085s0.256-0.485 0.085-0.702zM8.189 15.256c0.906 0.796 2.069 1.244 3.3 1.244 1.255 0 2.439-0.465 3.352-1.29 0.205-0.185 0.221-0.501 0.036-0.706s-0.501-0.221-0.706-0.036c-0.73 0.66-1.676 1.032-2.681 1.032-0.986 0-1.915-0.357-2.64-0.995-0.207-0.182-0.523-0.162-0.706 0.045s-0.162 0.523 0.045 0.706zM14.871 7.817c-0.916-0.842-2.113-1.317-3.382-1.317-1.241 0-2.412 0.454-3.321 1.262-0.206 0.183-0.225 0.499-0.042 0.706s0.499 0.225 0.706 0.042c0.727-0.646 1.663-1.009 2.656-1.009 1.016 0 1.972 0.38 2.705 1.054 0.203 0.187 0.52 0.173 0.706-0.030s0.173-0.52-0.030-0.706zM11.5 12.5c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1s0.448 1 1 1z"
      }
    })]);
  }
};
export var SvgCenter = {
  name: 'SvgCenter',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M19.857 11.646l-7.5-7.5c-0.094-0.094-0.221-0.146-0.354-0.146s-0.26 0.053-0.354 0.146l-7.5 7.5c-0.128 0.126-0.179 0.311-0.133 0.485s0.182 0.31 0.356 0.356c0.174 0.046 0.359-0.005 0.485-0.133l7.147-7.146 7.146 7.146c0.196 0.193 0.51 0.192 0.705-0.002s0.195-0.509 0.002-0.705zM12.354 7.146c-0.195-0.195-0.512-0.195-0.708 0l-5.5 5.5c-0.094 0.094-0.147 0.221-0.146 0.354v6c0 0.552 0.448 1 1 1 0 0 0 0 0 0h4v-4l2-0.009v4.009l4 0c0.552 0 1-0.448 1-1 0 0 0 0 0 0l-0-6c-0-0.133-0.053-0.26-0.147-0.354l-5.499-5.5z"
      }
    })]);
  }
};
export var SvgChildParkingLot = {
  name: 'SvgChildParkingLot',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M12 3c4.92 0 9 4.080 9 9s-4.080 9-9 9c-4.92 0-9-4.080-9-9s4.080-9 9-9zM12 4c-4.373 0-8 3.627-8 8s3.627 8 8 8c4.373 0 8-3.627 8-8s-3.627-8-8-8zM12 5c3.827 0 7 3.173 7 7s-3.173 7-7 7c-3.827 0-7-3.173-7-7s3.173-7 7-7zM12.5 8h-2.5v8h1v-3h1.5c1.5 0 2.7-1.1 2.7-2.5s-1.2-2.5-2.7-2.5zM12.5 12h-1.5v-3h1.5c0.9 0 1.7 0.6 1.7 1.5s-0.8 1.5-1.7 1.5z"
      }
    })]);
  }
};
export var SvgCity = {
  name: 'SvgCity',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M18 7c0.552 0 1 0.448 1 1v11h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h0.5v-11c0-0.552 0.448-1 1-1h1v-1l2.723-1.815c0.168-0.112 0.387-0.112 0.555 0l2.723 1.815v1h2c0-0.552 0.448-1 1-1h1c0.552 0 1 0.448 1 1zM8 9v8h1v-8h-1zM11 9v8h1v-8h-1zM16 9v8h1v-8h-1z"
      }
    })]);
  }
};
export var SvgCommandCenter = {
  name: 'SvgCommandCenter',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M4.584 5.188c2.043-1.456 3.862-1.99 3.862-1.99 2.388-0.875 3.592 1.437 3.592 1.437 2.077 3.147 4.325 2.855 4.325 2.855 2.702 0.152 4.077-1.17 4.077-1.17l0.071-0.037c0.63-0.244 0.462 0.238 0.462 0.581-0.028 0.243-0.028 0.702-0.423 1.464s-0.611 1.394-1.549 2.672c-0.938 1.278-1.009 1.592-2.505 2.85s-3.065-0.248-3.065-0.248c-0.68-0.644-1.429-0.914-1.429-0.914-1.899-0.513-3.841 1.008-4.573 1.669l1.534 5.368c0.152 0.531-0.156 1.085-0.687 1.236s-1.085-0.156-1.236-0.687l-4-14c-0.152-0.531 0.156-1.085 0.687-1.236 0.306-0.087 0.619-0.023 0.858 0.149z"
      }
    })]);
  }
};
export var SvgDepartment = {
  name: 'SvgDepartment',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M6 20v-16c0-0.552 0.448-1 1-1h10c0.552 0 1 0.448 1 1v16h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-13c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h0.5zM8 8v11h8v-11h-8zM9 9h6v9h-6v-9zM13 13v2h1v-2h-1zM9 5v1h6v-1h-6z"
      }
    })]);
  }
};
export var SvgDevice = {
  name: 'SvgDevice',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M21 7.3c0-0.1-0.1-0.1-0.1-0.2l-2-2c-0.1-0.1-0.3-0.1-0.4-0.1h-13c-0.1 0-0.3 0-0.4 0.1l-2 2c0 0-0.1 0.1-0.1 0.2s0 0.1 0 0.2v8.5c0 0.552 0.448 1 1 1h2v1h2v-1h8v1h2v-1h2c0.552 0 1-0.448 1-1v-8.5c0-0.1 0-0.1 0-0.2zM4.7 7l1-1h12.6l1 1h-14.6zM6 11h1v2h-1v-2zM9 11h1v2h-1v-2zM12 11h1v2h-1v-2zM17 14c-1.067 0-2-0.933-2-2s0.933-2 2-2c1.067 0 2 0.933 2 2s-0.933 2-2 2zM17 11c-0.6 0-1 0.4-1 1s0.4 1 1 1c0.6 0 1-0.4 1-1s-0.4-1-1-1z"
      }
    })]);
  }
};
export var SvgDistrict = {
  name: 'SvgDistrict',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M7 6h-1l3.776-1.888c0.141-0.070 0.306-0.070 0.447 0l3.776 1.888h-1v1c0.552 0 1 0.448 1 1v11h1v-8c0-0.552 0.448-1 1-1v-1.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1.5c0.552 0 1 0.448 1 1v8h1.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1.5v-11c0-0.552 0.448-1 1-1v-1zM16 13v1h1v-1h-1zM16 16v1h1v-1h-1zM9 10v7h2v-7h-2zM10 8c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1s0.448 1 1 1z"
      }
    })]);
  }
};
export var SvgDomeCamera = {
  name: 'SvgDomeCamera',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M5.14 4h13.72c0.63 0 1.14 0.51 1.14 1.14v0.72c0 0.63-0.51 1.14-1.14 1.14h-13.72c-0.63 0-1.14-0.51-1.14-1.14v-0.72c0-0.63 0.51-1.14 1.14-1.14zM6 5v1h1v-1h-1zM18.857 13.016c0 3.851-3.075 6.984-6.856 6.984s-6.856-3.133-6.856-6.984c-0.006-3.201-0.002-4.873 0.012-5.016h13.685c0.013 0.143 0.018 1.815 0.015 5.016zM12.106 11.11c-1.753 0-3.173 1.42-3.173 3.173s1.42 3.173 3.173 3.173c1.753 0 3.173-1.42 3.173-3.173s-1.42-3.173-3.173-3.173zM11.345 14.665c-0.63 0-1.143-0.513-1.143-1.143s0.513-1.143 1.143-1.143c0.63 0 1.143 0.513 1.143 1.143s-0.512 1.143-1.143 1.143z"
      }
    })]);
  }
};
export var SvgDoorStation = {
  name: 'SvgDoorStation',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "width": "24px",
        "height": "24px",
        "viewBox": "0 0 24 24",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [h("g", {
      "attrs": {
        "id": "Main",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [h("g", {
      "attrs": {
        "id": "Tree/Main/Door_station",
        "fill": "#6F7E91",
        "fill-rule": "nonzero"
      }
    }, [h("g", {
      "attrs": {
        "id": "tree_main_door_station",
        "transform": "translate(5.000000, 4.000000)"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M1,0 L13,0 C13.552,0 14,0.448 14,1 L14,16 C14,16.552 13.552,17 13,17 L1,17 C0.448,17 0,16.552 0,16 L0,1 C0,0.448 0.448,0 1,0 Z M6,1 C5.724,1 5.5,1.224 5.5,1.5 C5.5,1.776 5.724,2 6,2 L8,2 C8.276,2 8.5,1.776 8.5,1.5 C8.5,1.224 8.276,1 8,1 L6,1 Z M13,14 L11,14 C10.448,14 10,13.552 10,13 C10,12.448 10.448,12 11,12 L13,12 L13,11 L11,11 C9.895,11 9,11.895 9,13 C9,14.105 9.895,15 11,15 L13,15 L13,14 Z M4,12 L4,13 L5,13 L5,12 L4,12 Z M4,14 L4,15 L5,15 L5,14 L4,14 Z M6,12 L6,13 L7,13 L7,12 L6,12 Z M6,14 L6,15 L7,15 L7,14 L6,14 Z M2,12 L2,13 L3,13 L3,12 L2,12 Z M2,14 L2,15 L3,15 L3,14 L2,14 Z M1,3 L1,10 L13,10 L13,3 L1,3 Z M2,4 L12,4 L12,9 L2,9 L2,4 Z",
        "id": "形状"
      }
    })])])])]);
  }
};
export var SvgDoorStationWall = {
  name: 'SvgDoorStationWall',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "width": "24px",
        "height": "24px",
        "viewBox": "0 0 24 24",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [h("g", {
      "attrs": {
        "id": "Main",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [h("g", {
      "attrs": {
        "id": "Tree/Main/Door_station_wall",
        "fill": "#6F7E91",
        "fill-rule": "nonzero"
      }
    }, [h("g", {
      "attrs": {
        "id": "tree_main_door_station_wall",
        "transform": "translate(4.000000, 5.000000)"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M11,10 L11,13 C11,13.552 10.552,14 10,14 L1,14 C0.448,14 0,13.552 0,13 L0,1 C0,0.448 0.448,0 1,0 L10,0 C10.552,0 11,0.448 11,1 L11,6 L12,6 L12,4 L13,2 L14,4 L14,6 L15,6 L15,4 L16,2 L17,4 L17,13 L15,13 L15,10 L14,10 L14,13 L12,13 L12,10 L11,10 Z M11,9 L12,9 L12,7 L11,7 L11,9 Z M15,9 L15,7 L14,7 L14,9 L15,9 Z M1,2 L1,8 L10,8 L10,2 L1,2 Z M2,3 L9,3 L9,7 L2,7 L2,3 Z M10,12 L9,12 C8.448,12 8,11.552 8,11 C8,10.448 8.448,10 9,10 L10,10 L10,9 L9,9 C7.895,9 7,9.895 7,11 C7,12.105 7.895,13 9,13 L10,13 L10,12 Z M4,9 L4,10 L5,10 L5,9 L4,9 Z M4,11 L4,12 L5,12 L5,11 L4,11 Z M2,9 L2,10 L3,10 L3,9 L2,9 Z M2,11 L2,12 L3,12 L3,11 L2,11 Z",
        "id": "形状"
      }
    })])])])]);
  }
};
export var SvgDriver = {
  name: 'SvgDriver',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M17.009 15.691c0.226 0.092 0.383 0.186 1.043 0.634 1.948 1.275 1.948 3.825 1.948 3.825 0 0.425 0 0.85-0.417 0.85h-2.613c0.020-0.164 0.031-0.331 0.031-0.5 0-1.28-0.594-2.435-1.546-3.254l1.555-1.555zM16.010 15.276l-1.39 1.39c-0.762-0.422-1.659-0.666-2.619-0.666-2.761 0-5 2.015-5 4.5 0 0.169 0.010 0.336 0.031 0.5h-2.335c-0.417 0-0.696-0.425-0.696-0.85 0 0 0-2.975 2.087-4.108 1.252-0.708 0.696-0.142 2.365-0.85 1.53-0.708 1.252-0.85 1.252-0.85v-1.558c0 0-0.835-0.425-0.974-1.983-0.417 0-0.557-0.567-0.557-0.992s-0.278-1.417 0.278-1.417c-0.139-0.708-0.139-1.417-0.139-1.842 0.139-1.133 1.391-2.408 3.339-2.55 2.226 0.142 3.2 1.417 3.339 2.692 0 0.425 0 0.992-0.139 1.842 0.557-0.142 0.278 0.992 0.278 1.417s-0.139 0.992-0.557 0.85c-0.139 1.558-0.835 1.983-0.835 1.983v1.558c0 0 0.557 0.142 2.087 0.85 0.065 0.030 0.126 0.058 0.184 0.084zM8.041 21c-0.027-0.164-0.041-0.331-0.041-0.5 0-1.908 1.769-3.5 4-3.5s4 1.592 4 3.5c0 0.169-0.014 0.336-0.041 0.5h-7.918z"
      }
    })]);
  }
};
export var SvgElevatorControl = {
  name: 'SvgElevatorControl',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "width": "24px",
        "height": "24px",
        "viewBox": "0 0 24 24",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [h("desc", ["Created with Sketch."]), h("g", {
      "attrs": {
        "id": "Main",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [h("g", {
      "attrs": {
        "id": "Tree/Main/Elevator_control",
        "fill": "#6F7E91",
        "fill-rule": "nonzero"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M5,4 L18,4 C18.5522847,4 19,4.44771525 19,5 L19,19 C19,19.5522847 18.5522847,20 18,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,5 C4,4.44771525 4.44771525,4 5,4 Z M5,5 L5,19 L18,19 L18,5 L5,5 Z M6,6 L11,6 L11,18 L6,18 L6,6 Z M12,6 L17,6 L17,18 L12,18 L12,6 Z M9,11.7071068 L9.14644661,11.8535534 C9.34170876,12.0488155 9.65829124,12.0488155 9.85355339,11.8535534 C10.0488155,11.6582912 10.0488155,11.3417088 9.85355339,11.1464466 L8.85355339,10.1464466 C8.65829124,9.95118446 8.34170876,9.95118446 8.14644661,10.1464466 L7.14644661,11.1464466 C6.95118446,11.3417088 6.95118446,11.6582912 7.14644661,11.8535534 C7.34170876,12.0488155 7.65829124,12.0488155 7.85355339,11.8535534 L8,11.7071068 L8,13.5 C8,13.7761424 8.22385763,14 8.5,14 C8.77614237,14 9,13.7761424 9,13.5 L9,11.7071068 Z M15,12.2928932 L15,10.5 C15,10.2238576 14.7761424,10 14.5,10 C14.2238576,10 14,10.2238576 14,10.5 L14,12.2928932 L13.8535534,12.1464466 C13.6582912,11.9511845 13.3417088,11.9511845 13.1464466,12.1464466 C12.9511845,12.3417088 12.9511845,12.6582912 13.1464466,12.8535534 L14.1464466,13.8535534 C14.3417088,14.0488155 14.6582912,14.0488155 14.8535534,13.8535534 L15.8535534,12.8535534 C16.0488155,12.6582912 16.0488155,12.3417088 15.8535534,12.1464466 C15.6582912,11.9511845 15.3417088,11.9511845 15.1464466,12.1464466 L15,12.2928932 Z",
        "id": "Combined-Shape"
      }
    })])])]);
  }
};
export var SvgElevatorControlDevice = {
  name: 'SvgElevatorControlDevice',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "width": "24px",
        "height": "24px",
        "viewBox": "0 0 24 24",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [h("desc", ["Created with Sketch."]), h("g", {
      "attrs": {
        "id": "Main",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [h("g", {
      "attrs": {
        "id": "Tree/Main/Elevator_control_device",
        "fill": "#6F7E91",
        "fill-rule": "nonzero"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M19,13 L18,13 L18,5 L5,5 L5,19 L10,19 L10,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,5 C4,4.44771525 4.44771525,4 5,4 L18,4 C18.5522847,4 19,4.44771525 19,5 L19,13 Z M11,13 L10,13 L10,18 L6,18 L6,6 L11,6 L11,13 Z M17,13 L15.7071068,13 L15.8535534,12.8535534 C16.0488155,12.6582912 16.0488155,12.3417088 15.8535534,12.1464466 C15.6582912,11.9511845 15.3417088,11.9511845 15.1464466,12.1464466 L15,12.2928932 L15,10.5 C15,10.2238576 14.7761424,10 14.5,10 C14.2238576,10 14,10.2238576 14,10.5 L14,12.2928932 L13.8535534,12.1464466 C13.6582912,11.9511845 13.3417088,11.9511845 13.1464466,12.1464466 C12.9511845,12.3417088 12.9511845,12.6582912 13.1464466,12.8535534 L13.2928932,13 L12,13 L12,6 L17,6 L17,13 Z M9,11.7071068 L9.14644661,11.8535534 C9.34170876,12.0488155 9.65829124,12.0488155 9.85355339,11.8535534 C10.0488155,11.6582912 10.0488155,11.3417088 9.85355339,11.1464466 L8.85355339,10.1464466 C8.65829124,9.95118446 8.34170876,9.95118446 8.14644661,10.1464466 L7.14644661,11.1464466 C6.95118446,11.3417088 6.95118446,11.6582912 7.14644661,11.8535534 C7.34170876,12.0488155 7.65829124,12.0488155 7.85355339,11.8535534 L8,11.7071068 L8,13.5 C8,13.7761424 8.22385763,14 8.5,14 C8.77614237,14 9,13.7761424 9,13.5 L9,11.7071068 Z M18,20 L14,20 L14,21 L12,21 L12,20 L11,20 L11,14 L21,14 L21,20 L20,20 L20,21 L18,21 L18,20 Z M17,17 C17,17.5522847 17.4477153,18 18,18 C18.5522847,18 19,17.5522847 19,17 C19,16.4477153 18.5522847,16 18,16 C17.4477153,16 17,16.4477153 17,17 Z M13,16 L13,18 L14,18 L14,16 L13,16 Z M15,16 L15,18 L16,18 L16,16 L15,16 Z",
        "id": "Combined-Shape"
      }
    })])])]);
  }
};
export var SvgEntranceAndExit = {
  name: 'SvgEntranceAndExit',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M20 11v2c0 0.5-0.5 1-1 1h-3v-1h-1v1h-1v-1h-1v1h-1v-1h-1v1h-2v6c0 0.5-0.5 1-1 1h-3c-0.5 0-1-0.5-1-1v-12h5v2h3v1h1v-1h1v1h1v-1h1v1h1v-1h2c0.5 0 1 0.5 1 1zM5 3h3c0.552 0 1 0.448 1 1v3h-5v-3c0-0.552 0.448-1 1-1z"
      }
    })]);
  }
};
export var SvgEnviromentalVariable = {
  name: 'SvgEnviromentalVariable',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M15 8.959c-0.878-1.335-2.044-2.822-3.5-4.459-2.425 2.728-4.048 5.037-4.869 6.927 0.569-0.526 1.335-0.927 2.369-0.927 2.5 0 3 3.5 5 3.5 0.363 0 0.696-0.029 1-0.095v6.077c-0.982 0.646-2.168 1.018-3.5 1.018-3.866 0-6.5-3.134-6.5-7 0-2.577 2.167-6.244 6.5-11 1.389 1.525 2.556 2.938 3.5 4.239v1.72zM18 5v15c0 0.552-0.448 1-1 1s-1-0.448-1-1v-15c0-0.552 0.448-1 1-1s1 0.448 1 1z"
      }
    })]);
  }
};
export var SvgEvent = {
  name: 'SvgEvent',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M8 5v2h8v-2h1.993c0.556 0 1.007 0.445 1.007 1.001v13.998c0 0.553-0.45 1.001-1.007 1.001h-11.986c-0.556 0-1.007-0.445-1.007-1.001v-13.998c0-0.553 0.45-1.001 1.007-1.001h1.993zM7 9v1h10v-1h-10zM7 12v1h10v-1h-10zM7 15v1h6v-1h-6zM10 4h4c0.552 0 1 0.448 1 1v1h-6v-1c0-0.552 0.448-1 1-1z"
      }
    })]);
  }
};
export var SvgFaceAndIdComparison = {
  name: 'SvgFaceAndIdComparison',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M15.5 20c0 0.552-0.448 1-1 1h-5c-0.552 0-1-0.448-1-1h-2.35c-0.635 0-1.15-0.515-1.15-1.15v-14.7c0-0.635 0.515-1.15 1.15-1.15h11.7c0.635 0 1.15 0.515 1.15 1.15v14.7c0 0.635-0.515 1.15-1.15 1.15h-2.35zM6 9v10h12v-10h-12zM11 5v2h2v-2h-2zM13.906 15.508c0.397 0.12 0.772 0.303 1.111 0.542 0.586 0.452 0.943 0.83 0.949 1.57 0 0.222-0.012 0.347-0.248 0.347 0 0-7.552 0.076-7.623 0s-0.099-0.243-0.095-0.347c0 0-0.012-1.153 1.002-1.688 0.639-0.34 0.396-0.063 1.181-0.41s0.639-0.451 0.639-0.451v-0.799c-0.312-0.226-0.498-0.587-0.5-0.972-0.208 0.056-0.271-0.229-0.278-0.41s-0.104-0.695 0.146-0.695c-0.046-0.289-0.065-0.582-0.056-0.875 0.18-0.781 0.88-1.33 1.681-1.32 1.139 0.042 1.583 0.695 1.653 1.299 0.002 0.293-0.023 0.586-0.076 0.875 0.25-0.049 0.146 0.5 0.132 0.695s-0.083 0.465-0.285 0.41c-0.013 0.371-0.167 0.724-0.431 0.986v0.792c0 0 0.313 0.111 1.097 0.451z"
      }
    })]);
  }
};
export var SvgFactory = {
  name: 'SvgFactory',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M15.759 7.333l-0.166 2.667h-2.618v2h2.493l-0.432 6.938c-0.001 0.021-0.002 0.041-0.002 0.062 0 0.541 0.43 0.982 0.967 0.999-0.011 0-0.023 0.001-0.034 0.001h-10.97c-0.551 0-0.997-0.48-0.997-1.050v-12.374c0-0.569 0.446-0.747 0.997-0.399l2.992 1.241v-0.842c0-0.569 0.446-0.747 0.997-0.399l2.992 1.241v-0.842c0-0.569 0.446-0.747 0.997-0.399l2.784 1.155zM11.978 10h-2.992v2h2.992v-2zM7.989 10h-2.992v2h2.992v-2zM17.904 4h0.192c0.527 0 0.964 0.409 0.998 0.936l0.904 14c0.036 0.551-0.382 1.027-0.933 1.062-0.021 0.001-0.043 0.002-0.064 0.002h-2c-0.552 0-1-0.448-1-1 0-0.021 0.001-0.043 0.002-0.064l0.904-14c0.034-0.526 0.471-0.936 0.998-0.936z"
      }
    })]);
  }
};
export var SvgFieldOfView = {
  name: 'SvgFieldOfView',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M12 6c-3.354 0-6.354 2-9 6 2.639 4 5.639 6 9 6s6.361-2 9-6c-2.646-4-5.646-6-9-6zM12 15c-1.7 0-3-1.3-3-3s1.3-3 3-3c1.7 0 3 1.3 3 3s-1.3 3-3 3zM14 12c0 1.1-0.9 2-2 2s-2-0.9-2-2c0-1.1 0.9-2 2-2s2 0.9 2 2z"
      }
    })]);
  }
};
export var SvgFloor = {
  name: 'SvgFloor',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M11.5 21c-4.694 0-8.5-3.806-8.5-8.5s3.806-8.5 8.5-8.5c4.694 0 8.5 3.806 8.5 8.5s-3.806 8.5-8.5 8.5zM13 11h3v-2h-4v2h-3v2h-3v2h4v-2h3v-2z"
      }
    })]);
  }
};
export var SvgGateway = {
  name: 'SvgGateway',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "width": "24px",
        "height": "24px",
        "viewBox": "0 0 24 24",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [h("g", {
      "attrs": {
        "id": "Main",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [h("g", {
      "attrs": {
        "id": "Tree/Main/Gateway",
        "fill": "#6F7E91",
        "fill-rule": "nonzero"
      }
    }, [h("g", {
      "attrs": {
        "id": "tree_main_gateway",
        "transform": "translate(5.000000, 5.000000)"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M2.143,8.8817842e-16 L12.857,8.8817842e-16 C14.041,8.8817842e-16 15,0.959 15,2.143 L15,12.857 C15,14.041 14.041,15 12.857,15 L2.143,15 C0.959,15 0,14.041 0,12.857 L0,2.143 C0,0.959 0.959,0 2.143,8.8817842e-16 Z M11.526,5.051 C10.431,4.059 9.008,3.5 7.5,3.5 C6.016,3.5 4.615,4.041 3.526,5.004 C3.319,5.187 3.3,5.503 3.483,5.71 C3.666,5.917 3.982,5.936 4.189,5.753 C5.097,4.95 6.263,4.5 7.5,4.5 C8.758,4.5 9.941,4.965 10.855,5.792 C11.06,5.977 11.376,5.962 11.561,5.757 C11.746,5.552 11.731,5.236 11.526,5.051 L11.526,5.051 Z M10.138,6.493 C9.924,6.305 9.69,6.14 9.44,6.001 C8.851,5.674 8.187,5.5 7.499,5.5 C6.838,5.5 6.2,5.661 5.628,5.964 C5.37,6.101 5.128,6.265 4.906,6.454 C4.696,6.633 4.67,6.949 4.85,7.159 C5.03,7.369 5.345,7.395 5.555,7.215 C5.722,7.073 5.903,6.95 6.097,6.847 C6.525,6.62 7.003,6.5 7.499,6.5 C8.016,6.5 8.513,6.63 8.954,6.876 C9.141,6.98 9.317,7.104 9.478,7.245 C9.685,7.427 10.001,7.407 10.184,7.199 C10.367,6.991 10.346,6.676 10.138,6.493 L10.138,6.493 Z M7.5,11 C8.328,11 9,10.328 9,9.5 C9,8.672 8.328,8 7.5,8 C6.672,8 6,8.672 6,9.5 C6,10.328 6.672,11 7.5,11 Z",
        "id": "形状"
      }
    })])])])]);
  }
};
export var SvgGisMap = {
  name: 'SvgGisMap',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M20 11.622c-0.608-0.394-1.333-0.622-2.111-0.622-2.148 0-3.889 1.741-3.889 3.889 0 0.826 0.258 1.592 0.697 2.222l1.567 1.91-1.465 0.879c-0.2 0.1-0.4 0.1-0.5 0l-4.7-2.8-4.7 2.8c-0.5 0.2-0.9 0-0.9-0.4v-12c0-0.2 0.1-0.3 0.2-0.4l5-3c0.2-0.1 0.4-0.1 0.6 0l4.7 2.8 4.7-2.8c0.3-0.2 0.8 0 0.8 0.4v7.122zM10 16.2l4 2.4v-10.8l-4-2.4v10.8zM18 12c1.657 0 3 1.343 3 3 0 0.637-0.199 1.228-0.538 1.714l-2.462 3-2.462-3c-0.339-0.486-0.538-1.077-0.538-1.714 0-1.657 1.343-3 3-3zM18 16.286c0.71 0 1.286-0.576 1.286-1.286s-0.576-1.286-1.286-1.286c-0.71 0-1.286 0.576-1.286 1.286s0.576 1.286 1.286 1.286z"
      }
    })]);
  }
};
export var SvgGroup = {
  name: 'SvgGroup',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M11 6h8c0.552 0 1 0.448 1 1v11c0 0.552-0.448 1-1 1h-15c-0.552 0-1-0.448-1-1v-12c0-0.552 0.448-1 1-1h6c0.552 0 1 0.448 1 1zM10 7v-1h-6v3h15v-2h-9z"
      }
    })]);
  }
};
export var SvgHeadquarter = {
  name: 'SvgHeadquarter',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M16 5h1c0.552 0 1 0.448 1 1v14h1.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1.5v-14c0-0.552 0.448-1 1-1h1v-1c0-0.552 0.448-1 1-1h5c0.552 0 1 0.448 1 1v1zM12 12v2h1v-2h-1zM12 8v2h1v-2h-1zM9 8v2h1v-2h-1zM15 12v2h1v-2h-1zM15 8v2h1v-2h-1zM9 12v2h1v-2h-1zM11 16v4h3v-4h-3z"
      }
    })]);
  }
};
export var SvgHeadset = {
  name: 'SvgHeadset',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M20 15.050c-0.008-0.002-0.017-0.003-0.025-0.005-0.238-2.283-2.151-4.045-4.475-4.045-0.925 0-1.785 0.279-2.5 0.758v-0.758h-1v1.671c-0.537 0.663-0.889 1.482-0.978 2.378-0.997 0.197-1.773 0.97-1.972 1.951h-1.050v1h-2v-1h-2c-0.552 0-1-0.448-1-1v-8.5c0-0.1 0-0.1 0-0.2s0.1-0.2 0.1-0.2l2-2c0.1-0.1 0.3-0.1 0.4-0.1h12c0.1 0 0.3 0 0.4 0.1l2 2c0 0.1 0.1 0.1 0.1 0.2s0 0.1 0 0.2v7.55zM17 17v1h-2v-1h-1v-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v1.5zM4.7 7h13.6l-1-1h-11.6l-1 1zM6 11v2h1v-2h-1zM9 11v2h1v-2h-1zM19.5 19h-1.5v-3.5c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v3.5h-1.5c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.134 0.004 0.263-0.048 0.358-0.142s0.146-0.224 0.142-0.358c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c-0.004 0.134 0.048 0.263 0.142 0.358s0.224 0.146 0.358 0.142c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5z"
      }
    })]);
  }
};
export var SvgIntelligentLock = {
  name: 'SvgIntelligentLock',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "width": "24px",
        "height": "24px",
        "viewBox": "0 0 24 24",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [h("g", {
      "attrs": {
        "id": "Main",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [h("g", {
      "attrs": {
        "id": "Tree/Main/Intelligent_lock",
        "fill": "#6F7E91",
        "fill-rule": "nonzero"
      }
    }, [h("g", {
      "attrs": {
        "id": "tree_main_intelligent_lock",
        "transform": "translate(5.000000, 3.000000)"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M12,10 L5.909,10 C4.804,10 3.909,10.895 3.909,12 C3.909,13.105 4.804,14 5.909,14 L12,14 L12,17 C12,17.552 11.552,18 11,18 L1,18 C0.448,18 0,17.552 0,17 L0,1 C0,0.448 0.448,0 1,0 L11,0 C11.552,0 12,0.448 12,1 L12,10 Z M6,17 C6.552,17 7,16.552 7,16 C7,15.448 6.552,15 6,15 C5.448,15 5,15.448 5,16 C5,16.552 5.448,17 6,17 Z M6,11 L15,11 C15.552,11 16,11.448 16,12 C16,12.552 15.552,13 15,13 L6,13 C5.448,13 5,12.552 5,12 C5,11.448 5.448,11 6,11 Z M1,1 L1,8 L11,8 L11,1 L1,1 Z M2,2 L10,2 L10,7 L2,7 L2,2 Z",
        "id": "形状"
      }
    })])])])]);
  }
};
export var SvgLabel = {
  name: 'SvgLabel',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M16 17.492v-10.482c0-0.552-0.448-1-1-1h-6v-1.010c0-0.552 0.448-1 1-1h7c0.552 0 1 0.448 1 1v13.303c0 0.276-0.224 0.5-0.5 0.5-0.134 0-0.262-0.054-0.356-0.149l-1.144-1.161zM6 7.015h8c0.552 0 1 0.448 1 1v12.479c0 0.276-0.224 0.5-0.5 0.5-0.115 0-0.226-0.040-0.315-0.112l-3.554-2.887c-0.367-0.298-0.894-0.298-1.261 0l-3.554 2.887c-0.214 0.174-0.529 0.141-0.703-0.073-0.072-0.089-0.112-0.2-0.112-0.315v-12.479c0-0.552 0.448-1 1-1z"
      }
    })]);
  }
};
export var SvgLane = {
  name: 'SvgLane',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M11 19h-7.5l2.5-14h5v2h1v-2h5l2.5 14h-7.5v-4h-1v4zM11 9v4h1v-4h-1z"
      }
    })]);
  }
};
export var SvgLicense = {
  name: 'SvgLicense',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M4 7c2.281-0.631 5-2 7.5-4 2.5 2 5.219 3.369 7.5 4 0 8.060-2.733 12-7.5 14-4.767-2-7.5-5.94-7.5-14zM12.254 13.209v-1.325c0.371-0.117 0.719-0.322 1.013-0.616 0.976-0.976 0.976-2.559 0-3.536s-2.559-0.976-3.536 0c-0.976 0.976-0.976 2.559 0 3.536 0.361 0.361 0.806 0.589 1.272 0.683v5.009h1.25v-0.625h1.25v-1.25h-1.25v-0.625h1.25v-1.25h-1.25zM10.616 8.616c0.488-0.488 1.28-0.488 1.768 0s0.488 1.28 0 1.768c-0.488 0.488-1.28 0.488-1.768 0s-0.488-1.28 0-1.768z"
      }
    })]);
  }
};
export var SvgLocation = {
  name: 'SvgLocation',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M20 5v14h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-16c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h0.5v-14h-0.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h16c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-0.5zM7 7v6h11.007v-6h-11.007zM8 8h9.007v4h-9.007v-4zM10 15v4h2v-4h-2zM13 15v4h2v-4h-2z"
      }
    })]);
  }
};
export var SvgMap = {
  name: 'SvgMap',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M4 19.5v-12c0-0.2 0.1-0.3 0.2-0.4l5-3c0.2-0.1 0.4-0.1 0.6 0l4.7 2.8 4.7-2.8c0.3-0.2 0.8 0 0.8 0.4v12c0 0.2-0.1 0.3-0.2 0.4l-5 3c-0.2 0.1-0.4 0.1-0.5 0l-4.7-2.8-4.7 2.8c-0.5 0.2-0.9 0-0.9-0.4zM10 16.2l4 2.4v-10.8l-4-2.4v10.8z"
      }
    })]);
  }
};
export var SvgMapLink = {
  name: 'SvgMapLink',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M14.603 10.347l0.059 0.059c1.574 1.574 1.574 4.15 0 5.724l-3.197 3.197c-1.575 1.575-4.149 1.575-5.724 0l-0.059-0.059c-1.575-1.575-1.575-4.15-0-5.724l3.108-3.11-0.019 1.234c-0.009 0.599 0.1 1.193 0.324 1.745l0.124 0.307-1.68 1.681c-0.554 0.554-0.554 1.456 0 2.010l0.059 0.059c0.554 0.554 1.456 0.554 2.010 0l3.197-3.197c0.554-0.554 0.554-1.456 0-2.010l-0.059-0.059c-0.083-0.083-0.177-0.155-0.284-0.218l-0.555-0.328 1.934-1.932 0.347 0.262c0.149 0.113 0.288 0.232 0.416 0.36zM19.327 11.465l-3.111 3.11 0.021-1.236c0.010-0.597-0.1-1.191-0.324-1.744l-0.124-0.307 1.681-1.68c0.554-0.554 0.554-1.457 0-2.011l-0.059-0.059c-0.555-0.554-1.457-0.554-2.011-0l-3.197 3.197c-0.554 0.554-0.554 1.456 0 2.010l0.062 0.062c0.079 0.079 0.172 0.15 0.28 0.214l0.557 0.327-1.935 1.937-0.348-0.265c-0.154-0.117-0.29-0.234-0.414-0.359l-0.059-0.059c-1.574-1.575-1.574-4.149 0-5.724l3.197-3.197c1.575-1.574 4.15-1.574 5.728 0.003l0.058 0.059c1.573 1.574 1.572 4.148-0.002 5.723z"
      }
    })]);
  }
};
export var SvgMapMarking = {
  name: 'SvgMapMarking',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M9 13h-2v6c0.6 0 1 0.4 1 1h-4c0-0.6 0.4-1 1-1v-14.5c0-0.3 0.2-0.5 0.5-0.5s0.5 0.2 0.5 0.5v0.5h7.5c0.3 0 0.5 0.2 0.5 0.5v7.5h-5zM9 14h6v-7h3.5c0.2 0 0.5 0.1 0.5 0.3s0 0.4-0.2 0.6l-3.1 3.1 3.2 3.2c0.1 0.1 0.2 0.3 0.1 0.5s-0.3 0.3-0.5 0.3h-9c-0.3 0-0.5-0.2-0.5-0.5v-0.5z"
      }
    })]);
  }
};
export var SvgMicrophone = {
  name: 'SvgMicrophone',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M20 11c0-1.657-1.343-3-3-3s-3 1.343-3 3v1h-1v-1h-1v1h-0.002l0.002 1.002c0.003 1.613 0.779 3.079 2.015 3.998h-6.015v1h-2v-1h-2c-0.552 0-1-0.448-1-1v-8.5c0-0.1 0-0.1 0-0.2s0.1-0.2 0.1-0.2l2-2c0.1-0.1 0.3-0.1 0.4-0.1h12c0.1 0 0.3 0 0.4 0.1l2 2c0 0.1 0.1 0.1 0.1 0.2s0 0.1 0 0.2v3.5zM15 18v0zM4.7 7h13.6l-1-1h-11.6l-1 1zM6 11v2h1v-2h-1zM9 11v2h1v-2h-1zM18 16.859v2.141h-2v-2.141c-1.763-0.452-2.996-2.039-3-3.859h1c0 1.657 1.343 3 3 3s3-1.343 3-3h1c-0.004 1.82-1.237 3.407-3 3.859zM17 15c-1.105 0-2-0.895-2-2v-2c0-1.105 0.895-2 2-2s2 0.895 2 2v2c0 1.105-0.895 2-2 2z"
      }
    })]);
  }
};
export var SvgMiddleLargeSizeVehicle = {
  name: 'SvgMiddleLargeSizeVehicle',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M18 7c0.55 0 1 0.45 1 1v1c0 0.55-0.45 1-1 1v7.071c0 0.511-0.448 0.929-0.995 0.929h-0.005v1c0 0.55-0.45 1-1 1s-1-0.45-1-1v-1h-7v1c0 0.55-0.45 1-1 1s-1-0.45-1-1v-1h-0.005c-0.547 0-0.995-0.418-0.995-0.929v-7.071c-0.55 0-1-0.45-1-1v-1c0-0.55 0.45-1 1-1v-1.367c0-0.421 0.297-0.79 0.732-0.899 1.099-0.274 2.268-0.734 5.768-0.734s4.669 0.46 5.768 0.734c0.435 0.109 0.732 0.478 0.732 0.899v1.367zM7 12h9v-5h-9v5zM15 16c0.553 0 1-0.447 1-1s-0.447-1-1-1c-0.553 0-1 0.447-1 1s0.447 1 1 1zM8 16c0.553 0 1-0.447 1-1s-0.447-1-1-1c-0.553 0-1 0.447-1 1s0.447 1 1 1zM10.5 5c-0.275 0-0.5 0.225-0.5 0.5s0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5h-2z"
      }
    })]);
  }
};
export var SvgMonitoringPoint = {
  name: 'SvgMonitoringPoint',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M6 14h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h2v-1h-1c-0.552 0-1-0.448-1-1v-5c0-0.552 0.448-1 1-1h1v-0.5c0-0.276 0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5v0.5h2c0.552 0 1 0.448 1 1v5c0 0.552-0.448 1-1 1h-2v1h6v-1h-1c-0.552 0-1-0.448-1-1v-5c0-0.552 0.448-1 1-1h1v-0.5c0-0.276 0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5v0.5h2c0.552 0 1 0.448 1 1v5c0 0.552-0.448 1-1 1h-2v1h3c0.552 0 1 0.448 1 1s-0.448 1-1 1h-12v6c0 0.552-0.448 1-1 1s-1-0.448-1-1v-6z"
      }
    })]);
  }
};
export var SvgMonitoringPointOfWidthAndHeight = {
  name: 'SvgMonitoringPointOfWidthAndHeight',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M16 15h-1v-4c0-0.551-0.449-1-1-1s-1 0.449-1 1v4h-1v-4c0-0.551-0.449-1-1-1s-1 0.449-1 1v4h-1v-6h1v0.279c0.296-0.173 0.635-0.279 1-0.279 0.599 0 1.133 0.272 1.5 0.693 0.367-0.421 0.901-0.693 1.5-0.693 1.1 0 2 0.9 2 2v4zM20 5c0-0.55-0.45-1-1-1h-5l-2 2-2-2h-5c-0.55 0-1 0.45-1 1v5l2 2-2 2v5c0 0.55 0.45 1 1 1h5l2-2 2 2h5c0.55 0 1-0.45 1-1v-5l-2-2 2-2v-5z"
      }
    })]);
  }
};
export var SvgMotorcade = {
  name: 'SvgMotorcade',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M11 14h6v-4h-6v4zM16 17c0.553 0 1-0.447 1-1s-0.447-1-1-1c-0.553 0-1 0.447-1 1s0.447 1 1 1zM12 17c0.553 0 1-0.447 1-1s-0.447-1-1-1c-0.553 0-1 0.447-1 1s0.447 1 1 1zM13.5 8c-0.275 0-0.5 0.225-0.5 0.5s0.225 0.5 0.5 0.5h1c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5h-1zM19 10c0.55 0 1 0.45 1 1s-0.45 1-1 1v5.082c0 0.504-0.45 0.917-1 0.918v1c0 0.55-0.45 1-1 1s-1-0.45-1-1v-1h-4v1c0 0.55-0.45 1-1 1s-1-0.45-1-1v-1c-0.55-0.001-1-0.414-1-0.918v-5.082c-0.55 0-1-0.45-1-1s0.45-1 1-1v-1.469c0-0.384 0.255-0.728 0.648-0.858 0.821-0.272 2.368-0.673 4.352-0.673s3.531 0.401 4.352 0.673c0.393 0.13 0.648 0.474 0.648 0.858v1.469zM9.5 5c-0.275 0-0.5 0.225-0.5 0.5s0.225 0.5 0.5 0.5h1c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5h-1zM7 13c0 0.553 0.447 1 1 1v2c0 0.55-0.45 1-1 1s-1-0.45-1-1v-1c-0.55-0.001-1-0.414-1-0.918v-5.082c-0.55 0-1-0.45-1-1s0.45-1 1-1v-1.469c0-0.384 0.255-0.728 0.648-0.858 0.821-0.272 2.368-0.673 4.352-0.673s3.531 0.401 4.352 0.673c0.393 0.13 0.648 0.474 0.648 0.858v0.505c-0.322-0.021-0.652-0.036-1-0.036-2.159 0-3.851 0.453-4.666 0.724-0.197 0.065-0.379 0.159-0.54 0.276h-1.794v4c0 0.457 0.166 0.867 0.425 1.204-0.251 0.182-0.425 0.463-0.425 0.796z"
      }
    })]);
  }
};
export var SvgNoise = {
  name: 'SvgNoise',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M11.6 7l3.4-3v17l-3.4-3h-5.6c-0.5 0-1-0.4-1-1v-9c0-0.6 0.5-1 1-1h5.6zM15 10l2-1-0.5-1.6 4.5-0.4-3 1.5 1 1.5h-4zM15 15h4l-1 1.5 3 1.5-4.5-0.4 0.5-1.6-2-1z"
      }
    })]);
  }
};
export var SvgOrganization = {
  name: 'SvgOrganization',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M11 12v-1h-2c-0.552 0-1-0.448-1-1v-5c0-0.552 0.448-1 1-1h5c0.552 0 1 0.448 1 1v5c0 0.552-0.448 1-1 1h-2v1h3c0.552 0 1 0.448 1 1v2h2c0.552 0 1 0.448 1 1v4c0 0.552-0.448 1-1 1h-4c-0.552 0-1-0.448-1-1v-4c0-0.552 0.448-1 1-1h1v-2h-7v2h1c0.552 0 1 0.448 1 1v4c0 0.552-0.448 1-1 1h-4c-0.552 0-1-0.448-1-1v-4c0-0.552 0.448-1 1-1h2v-2c0-0.552 0.448-1 1-1h3z"
      }
    })]);
  }
};
export var SvgOverloadControlAtFixedLocation = {
  name: 'SvgOverloadControlAtFixedLocation',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M11.5 20c-2.923 0-4.5-1.064-4.5-1.5 0-0.409 1.408-1.362 4-1.478v1.978h1v-1.978c2.592 0.116 4 1.069 4 1.478 0 0.436-1.577 1.5-4.5 1.5zM9 7c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM12 16.012v-2.037c2.803-0.253 5-2.606 5-5.475 0-3.038-2.462-5.5-5.5-5.5s-5.5 2.462-5.5 5.5c0 2.869 2.197 5.222 5 5.475v2.037c-2.803 0.114-5 1.184-5 2.488 0 1.381 2.462 2.5 5.5 2.5s5.5-1.119 5.5-2.5c0-1.304-2.197-2.374-5-2.488z"
      }
    })]);
  }
};
export var SvgOverloadControlByTechnology = {
  name: 'SvgOverloadControlByTechnology',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M16.003 7c0.548 0 0.997 0.449 0.997 0.997v2.65l-0.058-0.186c-0.269-0.86-1.161-1.461-2.17-1.461h-5.543c-1.010 0-1.902 0.601-2.171 1.461l-0.058 0.186v-2.65c0-0.548 0.449-0.997 0.997-0.997h8.006zM18.997 4c0.554 0 1.003 0.449 1.003 1.003v14.997h-2v-14h-12v14h-2v-14.997c0-0.554 0.45-1.003 1.004-1.003h13.993zM15 17c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1s0.448 1 1 1zM8.358 13h7.282l-0.607-1.942c0 0.001-0.001 0.001-0.002 0.001-0.013 0-0.103-0.059-0.26-0.059h-5.542c-0.17 0-0.262 0.069-0.275 0.087l-0.596 1.913zM9 17c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1s0.448 1 1 1zM15.987 10.759l0.854 2.732c0.092 0.152 0.159 0.318 0.159 0.506v3.006c0 0.548-0.449 0.997-0.998 0.997h-0.002v1c0 0.55-0.45 1-1 1s-1-0.45-1-1v-1h-4v1c0 0.55-0.45 1-1 1s-1-0.45-1-1v-1h-0.002c-0.549 0-0.998-0.449-0.998-0.997v-3.006c0-0.188 0.067-0.354 0.159-0.506l0.854-2.732c0.139-0.446 0.64-0.759 1.216-0.759h5.542c0.576 0 1.077 0.313 1.216 0.759z"
      }
    })]);
  }
};
export var SvgOverloadControlFromSource = {
  name: 'SvgOverloadControlFromSource',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M17.017 14.882v-1.829l2.829 2.829-2.829 2.829v-1.829h-3v-2h3zM13.017 13.882v4h2v2h-9v-7h9v1h-2zM19.866 10.306c0.287 0.144 0.185 0.576-0.136 0.576h-1.713v1h-13v7.999c-0.552-0.003-1-0.45-1-1.004v-7.995h-1.712c-0.321 0-0.423-0.432-0.136-0.576l8.402-4.201c0.281-0.14 0.612-0.14 0.893 0l8.402 4.201z"
      }
    })]);
  }
};
export var SvgPanovuCamera = {
  name: 'SvgPanovuCamera',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M20.681 9.013c-1.062-0.96-2.125-1.6-3.506-2.133 0 0 0 0 0.106 0-0.956-1.707-2.763-2.88-4.781-2.88-2.125 0-3.931 1.173-4.781 2.987-1.275 0.533-2.444 1.28-3.4 2.24-0.213 0.213-0.319 0.427-0.319 0.747v3.2c0 0.32 0.106 0.533 0.319 0.747 1.169 1.067 2.444 1.813 3.931 2.24 0.213 2.133 2.019 3.84 4.25 3.84s4.038-1.707 4.25-3.84c1.488-0.427 2.763-1.28 3.931-2.24 0.213-0.213 0.319-0.427 0.319-0.747v-3.413c0-0.32-0.106-0.533-0.319-0.747zM9.312 6.453c0.85-0.853 1.912-1.387 3.188-1.387s2.337 0.533 3.081 1.387h0.106c-0.956-0.213-2.019-0.32-3.188-0.32s-2.337 0.107-3.294 0.427l0.106-0.107zM13.563 11.467c0 0.64-0.425 1.067-1.062 1.067s-1.062-0.427-1.062-1.067c0-0.64 0.425-1.067 1.062-1.067s1.062 0.427 1.062 1.067zM5.594 14.667c-0.319 0-0.531-0.213-0.531-0.533s0.213-0.533 0.531-0.533c0.319 0 0.531 0.213 0.531 0.533s-0.213 0.533-0.531 0.533zM8.25 13.6c-0.637 0-1.062-0.427-1.062-1.067s0.425-1.067 1.062-1.067c0.637 0 1.062 0.427 1.062 1.067s-0.425 1.067-1.062 1.067zM12.5 18.933c-1.806 0-3.188-1.387-3.188-3.2 0-0.427 0.106-0.747 0.213-1.067 0.531-0.747 1.594-1.067 2.975-1.067s2.444 0.32 3.081 1.067c0.106 0.32 0.213 0.64 0.213 1.067-0.106 1.813-1.488 3.2-3.294 3.2zM16.75 13.6c-0.638 0-1.062-0.427-1.062-1.067s0.425-1.067 1.062-1.067c0.637 0 1.062 0.427 1.062 1.067s-0.425 1.067-1.062 1.067zM19.406 14.667c-0.319 0-0.531-0.213-0.531-0.533s0.213-0.533 0.531-0.533c0.319 0 0.531 0.213 0.531 0.533s-0.213 0.533-0.531 0.533zM12.5 14.667c0.744 0 1.381 0.107 2.019 0.32 0.106 0.213 0.106 0.533 0.106 0.747 0 1.173-0.956 2.133-2.125 2.133s-2.125-0.96-2.125-2.133c0-0.213 0-0.533 0.106-0.747 0.637-0.213 1.275-0.32 2.019-0.32z"
      }
    })]);
  }
};
export var SvgParkingLot = {
  name: 'SvgParkingLot',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M11.5 4c4.647 0 8.5 3.853 8.5 8.5s-3.853 8.5-8.5 8.5c-4.647 0-8.5-3.853-8.5-8.5s3.853-8.5 8.5-8.5zM12.5 8h-3.5v10h1v-4h2.5c1.5 0 2.7-1.6 2.7-3s-1.2-3-2.7-3zM12.5 13h-2.5v-4h2.5c0.9 0 1.7 1.1 1.7 2s-0.8 2-1.7 2z"
      }
    })]);
  }
};
export var SvgPartition = {
  name: 'SvgPartition',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M11.5 21c-4-2.5-7.5-5-7.5-14 3.49-0.5 6.5-3 7.5-4 1 1 4 3.5 7.5 4 0 9-3.5 11.5-7.5 14zM15 11h-3v-3h-1v3h-3v1h3v3h1v-3h3v-1z"
      }
    })]);
  }
};
export var SvgPeopleDensityDetectionCamera = {
  name: 'SvgPeopleDensityDetectionCamera',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M9.565 9c-0.436 0.38-0.725 0.874-0.79 1.409-0.003 0.325 0.001 0.57 0.018 0.79-0.141 0.231-0.167 0.556-0.135 0.922 0.007 0.078 0.007 0.078 0.015 0.145 0.013 0.113 0.016 0.142 0.016 0.151 0 0.204 0.025 0.404 0.079 0.583h-0.697c-0.591 0-1.070-0.479-1.070-1.070v-2.93h2.565zM13.41 9h1.59v-1h-8v-1.93c0-0.591 0.479-1.070 1.070-1.070h10.86c0.591 0 1.070 0.479 1.070 1.070v5.86c0 0.591-0.479 1.070-1.070 1.070h-0.695c0-0.008 0.001-0.018 0.001-0.028 0.005-0.097 0.007-0.17 0.007-0.248 0-0.203-0.016-0.37-0.072-0.535-0.014-0.042-0.031-0.084-0.051-0.123 0.022-0.209 0.028-0.401 0.028-0.648-0.141-1.201-1.079-2.060-2.397-2.164l-0.129 0.001c-0.633 0.059-1.184 0.338-1.58 0.749l0.002 0.001c-0.129-0.39-0.344-0.729-0.636-1.003zM6 8h-2v1h2v2h-1.93c-0.591 0-1.070-0.479-1.070-1.070v-1.86c0-0.591 0.479-1.070 1.070-1.070h1.93v1zM13.906 15.583c0.894 0.417 0.569 0.167 1.3 0.667 1.137 0.75 1.137 2.25 1.137 2.25 0 0.25 0 0.5-0.244 0.5h-8.694c-0.244 0-0.406-0.25-0.406-0.5 0 0 0-1.75 1.219-2.417 0.731-0.417 0.406-0.083 1.381-0.5 0.894-0.417 0.731-0.5 0.731-0.5v-0.917c0 0-0.488-0.25-0.569-1.167-0.244 0-0.325-0.333-0.325-0.583s-0.162-0.833 0.162-0.833c-0.081-0.417-0.081-0.833-0.081-1.083 0.081-0.667 0.813-1.417 1.95-1.5 1.3 0.083 1.869 0.833 1.95 1.583 0 0.25 0 0.583-0.081 1.083 0.325-0.083 0.162 0.583 0.162 0.833s-0.081 0.583-0.325 0.5c-0.081 0.917-0.487 1.167-0.487 1.167v0.917c0 0 0.325 0.083 1.219 0.5zM20 18.583c0 0.25-0.162 0.417-0.406 0.417h-3.006c0.244-0.083 0.406-0.25 0.406-0.5 0 0 0-2-1.381-2.75-0.569-0.333-0.65-0.25-0.894-0.333v-0.833c0 0-0.325-0.25-0.406-1.083-0.162 0.083-0.244-0.25-0.244-0.417s-0.081-0.833 0.162-0.75c-0.081-0.417-0.081-0.75-0.081-0.917 0.081-0.667 0.65-1.333 1.544-1.417 1.056 0.083 1.625 0.75 1.706 1.417 0 0.167 0 0.583-0.081 0.917 0.244-0.083 0.162 0.583 0.162 0.75s-0.081 0.5-0.325 0.417c-0.081 0.833-0.569 1.083-0.569 1.083v0.833c0 0 0.162 0.083 1.056 0.5 0.813 0.417 0.569 0.083 1.219 0.5 1.137 0.5 1.137 2.167 1.137 2.167z"
      }
    })]);
  }
};
export var SvgPoisonousGas = {
  name: 'SvgPoisonousGas',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M16 17.997c0 0.001 0 0.002 0 0.003v2c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1 0 0.552-0.448 1-1 1s-1-0.448-1-1c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1v-2c0-0.001 0-0.002 0-0.003-2.391-1.297-4-3.721-4-6.497 0-4.142 3.582-7.5 8-7.5s8 3.358 8 7.5c0 2.776-1.609 5.2-4 6.497zM12 14.5c-0.5 0-1 0.833-1.5 2.5h3c-0.5-1.667-1-2.5-1.5-2.5zM8 14c1.1 0 2-1.125 2-2.5s-0.9-2.5-2-2.5c-1.1 0-2 1.125-2 2.5s0.9 2.5 2 2.5zM14 11.5c0 1.375 0.9 2.5 2 2.5s2-1.125 2-2.5c0-1.375-0.9-2.5-2-2.5s-2 1.125-2 2.5z"
      }
    })]);
  }
};
export var SvgPolePanicAlarmStation = {
  name: 'SvgPolePanicAlarmStation',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M18 19c0.552 0 1 0.448 1 1s-0.448 1-1 1h-12c-0.552 0-1-0.448-1-1s0.448-1 1-1v-13.85c0-0.635 0.515-1.15 1.15-1.15h9.7c0.635 0 1.15 0.515 1.15 1.15v13.85zM8 6v8h8v-8h-8zM11.15 7h1.7c0.635 0 1.15 0.515 1.15 1.15v2.85h-4v-2.85c0-0.635 0.515-1.15 1.15-1.15zM9.5 12h5c0.276 0 0.5 0.224 0.5 0.5v0c0 0.276-0.224 0.5-0.5 0.5h-5c-0.276 0-0.5-0.224-0.5-0.5v0c0-0.276 0.224-0.5 0.5-0.5z"
      }
    })]);
  }
};
export var SvgPortableDvr = {
  name: 'SvgPortableDvr',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M7 13h9v-5h-9v5zM14 17v-1h-2v-2h-1v2h-2v1h2v2h1v-2h2zM17 6c0.55 0 1 0.45 1 1v7c0 0.55-0.45 1-1 1v5c0 0.55-0.45 1-1 1h-9c-0.55 0-1-0.45-1-1v-5c-0.55 0-1-0.45-1-1v-7c0-0.55 0.45-1 1-1v-1h1v-2h1v2h1v1h8zM11 17v-1h1v1h-1zM8 12v-3h7v3h-7z"
      }
    })]);
  }
};
export var SvgPosTerminal = {
  name: 'SvgPosTerminal',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M16 16v4c0 0.552-0.448 1-1 1h-6c-0.552 0-1-0.448-1-1v-4h-2c-0.552 0-1-0.448-1-1v-11c0-0.552 0.448-1 1-1h12c0.552 0 1 0.448 1 1v11c0 0.552-0.448 1-1 1h-2zM8 6v2h8v-2h-8zM8.5 10c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1zM8.5 12c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1zM11.5 10c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1zM11.5 12c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1zM14.5 10c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1zM14.5 12c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1zM9 16v4h6v-4h-6zM12 16h2v4h-2v-4z"
      }
    })]);
  }
};
export var SvgPower = {
  name: 'SvgPower',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M11.5 21c-4.694 0-8.5-3.806-8.5-8.5s3.806-8.5 8.5-8.5c4.694 0 8.5 3.806 8.5 8.5s-3.806 8.5-8.5 8.5zM13.5 6.4l-6.5 5.1 4.5 2-2 5 5.5-6-4-1.5 2.5-4.6z"
      }
    })]);
  }
};
export var SvgPreset = {
  name: 'SvgPreset',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M3.884 4.385c-0.104-0.509 0.235-1 0.757-1.099s1.030 0.234 1.134 0.743l3.978 15.57c0.104 0.509-0.235 1-0.757 1.099s-1.030-0.234-1.134-0.743l-3.978-15.57zM18.286 12.346c-1.229 0.338-2.399 0.851-3.473 1.52-1.478 0.652-3.061 1.050-4.681 1.178l-2.466-11.015c2.415-1.006 5.521-0.284 7.16-0.507 0.868-0.118 2.524-0.355 4.173-0.522-0.923 1.466-1.824 2.721-2.24 4.394 1.611 1.464 3.039 3.108 4.252 4.898-0.907-0.119-1.826-0.101-2.726 0.054z"
      }
    })]);
  }
};
export var SvgPrison = {
  name: 'SvgPrison',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M15 12h-7v7h1v-6h6v6h1v-7h-1zM19 8v11h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h0.5v-11c-0.552 0-1-0.448-1-1v-2c0-0.552 0.448-1 1-1h2c0.552 0 1 0.448 1 1v2h2v-2c0-0.552 0.448-1 1-1h2c0.552 0 1 0.448 1 1v2h2v-2c0-0.552 0.448-1 1-1h2c0.552 0 1 0.448 1 1v2c0 0.552-0.448 1-1 1zM5 5v2h2v-2h-2zM11 5v2h2v-2h-2zM17 5v2h2v-2h-2zM7 9v1h2v-1h-2zM15 9v1h2v-1h-2zM11 9v1h2v-1h-2z"
      }
    })]);
  }
};
export var SvgProvince = {
  name: 'SvgProvince',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M9 6l2.723-1.815c0.168-0.112 0.387-0.112 0.555 0l2.723 1.815v2h3c0.552 0 1 0.448 1 1v10h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h0.5v-10c0-0.552 0.448-1 1-1h3v-2zM7 10v8h1v-8h-1zM16 10v8h1v-8h-1zM12 8c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1s0.448 1 1 1zM11 15v4h2v-4h-2z"
      }
    })]);
  }
};
export var SvgRemoteSite = {
  name: 'SvgRemoteSite',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M19.986 12h-6.986c-0.552 0-1 0.448-1 1v0.31c-0.208 0.146-0.096 0.229-0.385 0.157-0.164-0.042-0.347 0.058-0.504-0.050-0.141-0.097-0.174-0.368-0.037-0.482-0.069 0.057-0.066-0.126-0.118-0.159-0.080-0.053-0.212 0.008-0.305-0.012-0.125-0.031-0.198-0.043-0.17-0.165 0.031-0.132 0.381-0.492 0.022-0.482-0.194 0.005-0.256 0.294-0.464 0.336-0.232 0.048-0.433-0.032-0.553-0.238-0.252-0.427 0.146-0.955 0.553-0.993 0.317-0.029 0.783-0.264 1.016 0.087 0.068 0.103 0.235 0.497 0.32 0.242 0.027-0.078-0.066-0.417-0.096-0.559 0.065-0.1 0.17-0.163 0.252-0.251-0.011 0.011-0.022 0.022-0.033 0.033 0.081-0.082 0.297-0.176 0.334-0.29 0.022-0.061-0.073-0.142-0.023-0.228 0.038-0.067 0.129-0.041 0.165-0.083 0.052-0.062 0.058-0.167 0.113-0.232 0.056-0.068 0.163-0.077 0.22-0.127 0.13-0.12 0.165-0.254 0.319-0.327 0.145-0.097 0.297-0.264 0.48-0.189-0.066 0.076-0.233 0.122-0.282 0.193-0.033 0.049 0.25 0.021 0.286 0.007 0.16-0.058 0.286-0.177 0.42-0.265 0.231-0.152 0.498-0.16 0.777-0.104 0.085 0.018-0.155-0.328-0.18-0.357-0.096-0.111-0.121-0.21-0.278-0.066-0.045 0.042 0.125-0.143 0.145-0.231 0.028-0.129-0.274-0.338-0.343-0.398-0.149-0.127-0.228-0.199-0.312-0.396-0.088-0.21-0.146-0.42-0.369-0.265-0.083 0.058-0.023 0.183-0.167 0.203-0.090 0.012-0.182-0.102-0.233-0.156-0.077-0.080-0.16-0.277-0.301-0.296-0.122-0.015-0.464-0.195-0.624-0.078-0.122 0.089 0.016 0.427 0.054 0.549 0.079 0.26 0.129 0.27-0.091 0.432-0.109 0.081-0.174-0.005-0.136 0.211 0.022 0.111 0.142 0.134 0.056 0.231-0.053 0.058-0.179 0.053-0.24 0.025-0.193-0.090-0.020-0.211-0.114-0.338-0.068-0.096-0.438-0.174-0.564-0.232-0.279-0.127-1.016-0.26-0.788-0.693 0.061-0.118 0.292-0.29 0.395-0.359 0.109-0.069 0.243-0.087 0.332-0.183 0.050-0.054 0.054-0.203 0.099-0.239 0.064-0.053 0.25-0.029 0.35-0.025 0.429-0.086 0.038-0.71 0.604-0.597 0.156 0.032 0.313 0.191 0.441 0.278 0.147 0.1 0.193 0.087 0.148 0.239-0.011 0.036-0.172 0.193-0.213 0.225-0.076 0.058-0.198 0.085-0.286 0.121 0.296 0 0.419-0.014 0.659 0.146 0.208 0.138 0.336 0.229 0.59 0.218-0.016-0.123-0.233-0.075-0.224-0.197 0.007-0.103 0.137 0.033 0.153 0.033 0.072 0.004 0.255 0.087 0.214-0.11-0.035-0.174-0.414-0.090-0.292-0.374 0.17-0.018 0.123 0.168 0.236 0.208 0.121 0.043 0.277-0.102 0.302-0.202 0.11 0.037 0.171 0.361 0.199 0.368 0.083 0.021 0.61 0.092 0.59 0.17s-0.214-0.17-0.358-0.016c0.119 0.031 0.54 0.055 0.427 0.281-0.045 0.090-0.315 0.075-0.396 0.253 0.058-0.011 0.121 0.005 0.179-0.008-0.129 0.199 0.062 0.333 0.168 0.494 0.118 0.182 0.285 0.462 0.522 0.519 0.504 0.123 0.443-0.694 0.827-0.825 0.104-0.036 0.22-0.009 0.327-0.039 0.119-0.033 0.182-0.119 0.277-0.185 0.233-0.161 0.435-0.161 0.747-0.169-1.042-1.096-2.41-1.876-3.948-2.181-0.169 0.057-0.33 0.135-0.479 0.232 0.079 0.013 0.156 0.024 0.233 0.036-0.111 0.339-0.815-0.178-0.305-0.178s-0.001-0.101 0.114-0.162c-0.332-0.046-0.669-0.071-1.013-0.071-0.522-0-1.042 0.055-1.526 0.164-0.111 0.064-0.327 0.273-0.201 0.406 0.123 0.126 0.269-0.069 0.393-0.132 0.286-0.143 0.667-0.158 0.985-0.219-0.056 0.148-0.509 0.096-0.667 0.153-0.199 0.073-0.111 0.123-0.25 0.346 0.060-0.007 0.123 0.028 0.184 0.066-0.137-0.011-0.269-0.076-0.297 0.086-0.175-0.262-0.289-0.241-0.476-0.009 0.184 0.103 0.366 0.231 0.22 0.407-0.178 0.214-0.283-0.049-0.102-0.16-0.165-0.076-0.642 0.014-0.621-0.207-0.19-0.039-0.282-0.028-0.381-0.172-0.037-0.056-0.064-0.117-0.072-0.176-1.184 0.485-2.215 1.264-3.004 2.247 0.175 0.122 0.362 0.267 0.434 0.329 0.126 0.107 0.187 0.236 0.266 0.368 0.004 0.007 0.075 0.115 0.102 0.158 0.084 0.087 0.155 0.182 0.172 0.299 0.023 0.139-0.028 0.256-0.042 0.401-0.039 0.446 0.024 0.864 0.373 1.178 0.095 0.085 0.222 0.132 0.317 0.223 0.1 0.094 0.088 0.16 0.149 0.26 0.16 0.264 0.263 0.082 0.293 0.090 0.248 0.053 0.233 0.15 0.395 0.35 0.159 0.196 0.294 0.306 0.387 0.542 0.108 0.275 0.274 0.41 0.545 0.53 0.133 0.060 0.351 0.218 0.494 0.237 0.167 0.022 0.258-0.086 0.415-0.010 0.107 0.050 0.189 0.213 0.319 0.252 0.126 0.036 0.21-0.012 0.328 0.068 0.14 0.096 0.19 0.26 0.321 0.36 0.095 0.072 0.231 0.162 0.351 0.182 0.087 0.014 0.182-0.052 0.269-0.022 0.155 0.050 0.189 0.239 0.142 0.389-0.053 0.167-0.21 0.273-0.273 0.44-0.057 0.151-0.022 0.281-0.041 0.425-0.020 0.149-0.14-0.002-0.020 0.251 0.057 0.118 0.138 0.225 0.209 0.334 0.142 0.214 0.243 0.401 0.434 0.575 0.010 0.009 0.021 0.018 0.033 0.028v3.607c-0.022 0.031-0.042 0.063-0.056 0.101 0.021 0.001 0.040 0.003 0.056 0.005v1.265c-0.165 0.010-0.332 0.014-0.499 0.014-4.695 0-8.501-3.807-8.501-8.501s3.805-8.5 8.501-8.5c4.526 0 8.226 3.538 8.485 8zM20.5 13c0.2 0 0.3 0.1 0.4 0.2s0.1 0.2 0.1 0.3v5c0 0.3-0.2 0.5-0.5 0.5h-2.5v1h0.5c0.6 0 1 0.4 1 1h-5c0-0.1 0-0.3 0.1-0.4 0.2-0.4 0.5-0.6 0.9-0.6h0.5v-1h-2.5c-0.3 0-0.5-0.2-0.5-0.5v-5c0-0.3 0.2-0.5 0.5-0.5h7zM14 18h6v-1h-6v1z"
      }
    })]);
  }
};
export var SvgSecurityControlPanel = {
  name: 'SvgSecurityControlPanel',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M10 18v2h-5c-0.552 0-1-0.448-1-1s0.448-1 1-1h5zM17 13h-7v4h-5v-10c0-1.657 1.343-3 3-3h6c1.657 0 3 1.343 3 3v6zM8 10c-0.552 0-1 0.448-1 1v5h2v-5c0-0.552-0.448-1-1-1zM18 20h-4v1h-2v-1h-1v-6h10v6h-1v1h-2v-1zM15 16v2h1v-2h-1zM17 17c0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.552-0.448-1-1-1s-1 0.448-1 1zM13 16v2h1v-2h-1z"
      }
    })]);
  }
};
export var SvgSensor = {
  name: 'SvgSensor',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M17.5 14.5c0 0.3-0.2 0.5-0.5 0.5h-1v5h-1v1h-2v-1h-3v1h-2v-1h-1v-5h-1c-0.3 0-0.5-0.2-0.5-0.5s0.2-0.5 0.5-0.5h11c0.3 0 0.5 0.2 0.5 0.5zM16 13h-9c0 0 0-2.8 0-5s2.3-4 4.5-4c2.2 0 4.5 1.8 4.5 4 0 1.3 0 5 0 5zM9 8h-1v2.5h1v-2.5zM4 11.5c0 0.3 0.2 0.5 0.5 0.5s0.5-0.2 0.5-0.5v-2.5h-1v-1.5c0-0.3-0.2-0.5-0.5-0.5s-0.5 0.2-0.5 0.5v2.5h1v1.5zM19 14.5c0-0.3-0.2-0.5-0.5-0.5s-0.5 0.2-0.5 0.5v2.5h1v1.5c0 0.3 0.2 0.5 0.5 0.5s0.5-0.2 0.5-0.5v-2.5h-1v-1.5zM19.5 7c-0.3 0-0.5 0.2-0.5 0.5v1.5h-1v2.5c0 0.3 0.2 0.5 0.5 0.5s0.5-0.2 0.5-0.5v-1.5h1v-2.5c0-0.3-0.2-0.5-0.5-0.5zM4.5 14c-0.3 0-0.5 0.2-0.5 0.5v1.5h-1v2.5c0 0.3 0.2 0.5 0.5 0.5s0.5-0.2 0.5-0.5v-1.5h1v-2.5c0-0.3-0.2-0.5-0.5-0.5z"
      }
    })]);
  }
};
export var SvgServer = {
  name: 'SvgServer',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M5 20.5v0c0 0.276 0.224 0.5 0.5 0.5h13c0.276 0 0.5-0.224 0.5-0.5v0c0-0.276-0.224-0.5-0.5-0.5h-13c-0.276 0-0.5 0.224-0.5 0.5zM17 4c0.552 0 1 0.448 1 1v14h-12v-14c0-0.552 0.448-1 1-1h10zM7 6v1h10v-1h-10zM7 9h10v-1h-10v1zM7 11h10v-1h-10v1zM15 16h2v-2h-2v2z"
      }
    })]);
  }
};
export var SvgSite = {
  name: 'SvgSite',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M3 12.5c0 4.694 3.805 8.501 8.501 8.501 4.694 0 8.499-3.807 8.499-8.501s-3.805-8.5-8.499-8.5c-4.695 0-8.501 3.805-8.501 8.5zM16.093 7.467c-0.095 0.066-0.157 0.152-0.277 0.185-0.107 0.029-0.222 0.003-0.327 0.039-0.384 0.131-0.323 0.949-0.827 0.825-0.237-0.057-0.404-0.338-0.522-0.519-0.106-0.161-0.297-0.295-0.168-0.494-0.058 0.014-0.121-0.003-0.179 0.008 0.081-0.178 0.351-0.163 0.396-0.253 0.113-0.226-0.308-0.25-0.427-0.281 0.144-0.153 0.338 0.094 0.358 0.016s-0.507-0.149-0.59-0.17c-0.028-0.007-0.089-0.33-0.199-0.368-0.026 0.1-0.182 0.245-0.302 0.202-0.113-0.040-0.066-0.226-0.236-0.208-0.122 0.283 0.256 0.2 0.292 0.374 0.041 0.197-0.142 0.114-0.214 0.11-0.016 0-0.146-0.136-0.153-0.033-0.009 0.122 0.207 0.075 0.224 0.197-0.254 0.011-0.382-0.081-0.59-0.218-0.24-0.16-0.363-0.146-0.659-0.146 0.088-0.036 0.21-0.062 0.286-0.121 0.041-0.032 0.202-0.189 0.213-0.225 0.045-0.151-0.001-0.139-0.148-0.239-0.127-0.087-0.285-0.246-0.441-0.278-0.566-0.113-0.175 0.511-0.604 0.597-0.1-0.004-0.286-0.028-0.35 0.025-0.045 0.036-0.049 0.184-0.099 0.239-0.090 0.096-0.224 0.114-0.332 0.183-0.103 0.069-0.334 0.241-0.395 0.359-0.228 0.433 0.509 0.566 0.788 0.693 0.126 0.058 0.496 0.136 0.564 0.232 0.094 0.127-0.079 0.248 0.114 0.338 0.061 0.028 0.187 0.033 0.24-0.025 0.087-0.097-0.034-0.119-0.056-0.231-0.038-0.216 0.027-0.13 0.136-0.211 0.22-0.162 0.17-0.172 0.091-0.432-0.038-0.122-0.176-0.46-0.054-0.549 0.16-0.117 0.502 0.063 0.624 0.078 0.141 0.018 0.224 0.216 0.301 0.296 0.052 0.054 0.144 0.168 0.233 0.156 0.144-0.020 0.084-0.144 0.167-0.203 0.222-0.155 0.281 0.056 0.369 0.265 0.084 0.197 0.163 0.269 0.312 0.396 0.069 0.060 0.372 0.269 0.343 0.398-0.020 0.087-0.19 0.273-0.145 0.231 0.157-0.144 0.182-0.045 0.278 0.066 0.026 0.028 0.266 0.374 0.18 0.357-0.279-0.056-0.547-0.047-0.777 0.104-0.134 0.088-0.26 0.207-0.42 0.265-0.037 0.014-0.319 0.041-0.286-0.007 0.049-0.071 0.216-0.117 0.282-0.193-0.183-0.075-0.335 0.092-0.48 0.189-0.153 0.073-0.188 0.207-0.319 0.327-0.057 0.051-0.164 0.060-0.22 0.127-0.054 0.065-0.061 0.17-0.113 0.232-0.037 0.043-0.127 0.016-0.165 0.083-0.050 0.086 0.045 0.167 0.023 0.228-0.037 0.114-0.252 0.208-0.334 0.29 0.011-0.012 0.022-0.022 0.033-0.033-0.083 0.087-0.187 0.151-0.252 0.251 0.030 0.142 0.123 0.481 0.096 0.559-0.085 0.255-0.252-0.139-0.32-0.242-0.233-0.351-0.698-0.117-1.016-0.087-0.407 0.038-0.806 0.566-0.553 0.993 0.121 0.206 0.321 0.286 0.553 0.238 0.207-0.042 0.27-0.331 0.464-0.336 0.359-0.009 0.009 0.35-0.022 0.482-0.028 0.122 0.045 0.134 0.17 0.165 0.094 0.020 0.225-0.041 0.305 0.012 0.052 0.033 0.049 0.216 0.118 0.159-0.137 0.114-0.104 0.385 0.037 0.482 0.157 0.109 0.34 0.008 0.504 0.050 0.309 0.077 0.16-0.024 0.433-0.188 0.183-0.111 0.214 0.021 0.339 0.021 0.084 0 0.138-0.122 0.282-0.086 0.115 0.029 0.161 0.118 0.3 0.139 0.057 0.008 0.115-0.021 0.17-0.016 0.256 0.028 0.454 0.192 0.655 0.34 0.167 0.122 0.278 0.097 0.472 0.153 0.142 0.041 0.404 0.248 0.391 0.428-0.003 0.032 0.056 0.097 0.171 0.267 0.050-0.176 0.237 0.067 0.415 0.139 0.152 0.061 0.336 0.065 0.498 0.103 0.137 0.033 0.438 0.125 0.54 0.237 0.122 0.135 0.038 0.353-0.053 0.486-0.118 0.176-0.296 0.243-0.369 0.45-0.058 0.164-0.015 0.33-0.049 0.51-0.045 0.245-0.080 0.159-0.239 0.31-0.132 0.126-0.001 0.104-0.183 0.184s-0.342 0.057-0.468 0.256c-0.041 0.036-0.066 0.189-0.092 0.239-0.064 0.128-0.151 0.208-0.251 0.314-0.039 0.040-0.393 0.524-0.412 0.485-0.027-0.050-0.307 0.051-0.32-0.021 0.011 0.061-0.003 0.040 0.066 0.075-0.064 0.397-0.232 0.457-0.621 0.461 0.033 0.191-0.142 0.153-0.222 0.256-0.047 0.060-0.072 0.228-0.103 0.306-0.020 0.049-0.174 0.244-0.174 0.283 0 0.035 0.052 0.087 0.1 0.137-0.275 0.054-0.556 0.094-0.841 0.115 0.053-0.066 0.065-0.125-0.104-0.133 0.046-0.123 0.153-0.195 0.198-0.314 0.022-0.057 0.004-0.079 0.022-0.135 0.062-0.193 0.035-0.119 0-0.271-0.081-0.351 0.030-0.447 0.125-0.768 0.099-0.33 0.090-0.759 0.152-1.115 0.030-0.171 0.079-0.525 0.020-0.688-0.066-0.18-0.361-0.323-0.494-0.446-0.191-0.174-0.292-0.361-0.434-0.575-0.071-0.109-0.152-0.216-0.209-0.334-0.119-0.253 0-0.102 0.020-0.251 0.019-0.144-0.016-0.274 0.041-0.425 0.062-0.167 0.22-0.273 0.273-0.44 0.046-0.15 0.012-0.339-0.142-0.389-0.087-0.029-0.182 0.036-0.269 0.022-0.121-0.020-0.256-0.11-0.351-0.182-0.132-0.1-0.182-0.264-0.321-0.36-0.118-0.079-0.202-0.032-0.328-0.068-0.13-0.039-0.212-0.201-0.319-0.252-0.157-0.076-0.248 0.032-0.415 0.010-0.142-0.018-0.361-0.177-0.494-0.237-0.271-0.121-0.437-0.255-0.545-0.53-0.092-0.236-0.228-0.346-0.387-0.542-0.161-0.2-0.147-0.297-0.395-0.35-0.030-0.007-0.133 0.174-0.293-0.090-0.061-0.1-0.049-0.165-0.149-0.26-0.095-0.092-0.222-0.138-0.317-0.223-0.349-0.314-0.412-0.732-0.373-1.178 0.014-0.146 0.065-0.262 0.042-0.401-0.018-0.117-0.088-0.212-0.172-0.299-0.027-0.043-0.098-0.151-0.102-0.158-0.079-0.132-0.14-0.261-0.266-0.368-0.072-0.062-0.259-0.207-0.434-0.329 0.789-0.983 1.82-1.762 3.004-2.247 0.008 0.060 0.035 0.12 0.072 0.176 0.099 0.144 0.191 0.134 0.381 0.172-0.020 0.221 0.456 0.131 0.621 0.207-0.182 0.111-0.076 0.374 0.102 0.16 0.146-0.176-0.035-0.304-0.22-0.407 0.187-0.232 0.301-0.253 0.476 0.009 0.028-0.162 0.16-0.097 0.297-0.086-0.061-0.039-0.125-0.073-0.184-0.066 0.138-0.222 0.050-0.273 0.25-0.346 0.159-0.057 0.612-0.004 0.667-0.153-0.317 0.061-0.698 0.076-0.985 0.219-0.125 0.063-0.27 0.258-0.393 0.132-0.126-0.132 0.090-0.342 0.201-0.406 0.483-0.109 1.004-0.164 1.526-0.164 0.344 0 0.681 0.025 1.013 0.071-0.115 0.061 0.396 0.162-0.114 0.162s0.194 0.517 0.305 0.178c-0.077-0.012-0.155-0.023-0.233-0.036 0.149-0.097 0.31-0.175 0.479-0.232 1.538 0.304 2.906 1.085 3.948 2.181-0.312 0.008-0.514 0.008-0.747 0.169z"
      }
    })]);
  }
};
export var SvgSmartLinkageSystem = {
  name: 'SvgSmartLinkageSystem',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M7 5v-0.758c0-0.686 0.556-1.242 1.242-1.242h9.516c0.686 0 1.242 0.556 1.242 1.242v4.516c0 0.686-0.556 1.242-1.242 1.242h-4.209v0.908c3.002 0.288 4.22 2.452 4.22 5.030v1.013h-1.699c-0.543-1.192-1.782-1.95-3.224-1.95s-2.681 0.758-3.224 1.95h-1.699v-1.013c0-2.575 1.218-4.741 4.22-5.030v-0.908h-3.901c-0.686 0-1.242-0.556-1.242-1.242v-2.758h8v-1h-8zM6 5h-2v1h2v2h-1.758c-0.686 0-1.242-0.556-1.242-1.242v-1.516c0-0.686 0.556-1.242 1.242-1.242h1.758v1zM8.645 17.4h1.477c0.312-1.165 1.414-1.8 2.725-1.8s2.412 0.635 2.725 1.8h1.509c-0.259 2.019-1.709 3.565-4.17 3.599-0.021 0-0.043 0.001-0.064 0.001-2.549 0-3.95-1.598-4.201-3.6zM12.846 19.8c0.68 0 1.231-0.537 1.231-1.2s-0.551-1.2-1.231-1.2c-0.68 0-1.231 0.537-1.231 1.2s0.551 1.2 1.231 1.2z"
      }
    })]);
  }
};
export var SvgSmartLinkageSystemProbe = {
  name: 'SvgSmartLinkageSystemProbe',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M16.347 8.932c0.294 0.428 0.186 1.013-0.242 1.307s-1.013 0.186-1.307-0.242c-0.475-0.691-1.257-1.112-2.111-1.112-0.863 0-1.652 0.429-2.125 1.132-0.29 0.431-0.874 0.544-1.305 0.254s-0.544-0.874-0.254-1.305c0.819-1.216 2.189-1.962 3.684-1.962 1.48 0 2.838 0.73 3.66 1.926zM18.791 7.172c0.298 0.425 0.195 1.011-0.23 1.309s-1.011 0.195-1.309-0.23c-1.037-1.477-2.722-2.374-4.561-2.374-1.853 0-3.551 0.911-4.585 2.409-0.295 0.427-0.88 0.535-1.308 0.24s-0.535-0.88-0.24-1.308c1.381-2.001 3.654-3.221 6.132-3.221 2.458 0 4.715 1.2 6.1 3.174zM6 16h9v-1h-9v-2c0-0.552 0.448-1 1-1h12c0.552 0 1 0.448 1 1v7c0 0.552-0.448 1-1 1h-12c-0.552 0-1-0.448-1-1v-4zM5 15h-2v1h2v2h-2c-0.552 0-1-0.448-1-1v-2c0-0.552 0.448-1 1-1h2v1z"
      }
    })]);
  }
};
export var SvgSpeedDome = {
  name: 'SvgSpeedDome',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M11.479 20c-0.011 0-0.021 0-0.032 0-3.831 0-5.966-2.161-6.348-5.313h2.25c0.476-1.833 2.154-3.188 4.151-3.188s3.675 1.354 4.151 3.188h2.299c-0.394 3.177-2.604 5.257-6.353 5.311-0.032 0.001-0.065 0.001-0.097 0.001-0.007 0-0.014-0-0.021-0zM11.5 17.875c1.183 0 2.143-0.951 2.143-2.125s-0.959-2.125-2.143-2.125c-1.183 0-2.143 0.951-2.143 2.125s0.959 2.125 2.143 2.125zM11.5 16.812c-0.592 0-1.071-0.476-1.071-1.062s0.48-1.062 1.071-1.062c0.592 0 1.071 0.476 1.071 1.062s-0.48 1.062-1.071 1.062zM16.411 13.625c-0.827-1.876-2.715-3.188-4.911-3.188s-4.085 1.311-4.911 3.188h-2.589v-1.594c0-4.053 1.855-7.463 6.429-7.917v-0.583c0-0.293 0.24-0.531 0.536-0.531h1.071c0.296 0 0.536 0.238 0.536 0.531v0.583c4.573 0.454 6.429 3.859 6.429 7.917v1.594h-2.589z"
      }
    })]);
  }
};
export var SvgStorageServer = {
  name: 'SvgStorageServer',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M13 20h5.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-5.5v-1zM13 19v-5l-2-2h-4v-7c0-0.552 0.448-1 1-1h9c0.552 0 1 0.448 1 1v14h-5zM8 6v1h9v-1h-9zM8 9h9v-1h-9v1zM8 11h9v-1h-9v1zM15 16h2v-2h-2v2zM5 13h5l2 2v6h-7c-0.552 0-1-0.448-1-1v-6c0-0.552 0.448-1 1-1zM9 14h-2v1h-1v-1h-1v2h4v-2zM5 20h6v-3h-6v3z"
      }
    })]);
  }
};
export var SvgStreamingServer = {
  name: 'SvgStreamingServer',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M13 20h5.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-5.5v-1zM10 21h-4v-1h-1v1h-1v-7h1v1h1v-1h4v1h1v-1h1v7h-1v-1h-1v1zM13 19v-6h-6v-8c0-0.552 0.448-1 1-1h9c0.552 0 1 0.448 1 1v14h-5zM8 6v1h9v-1h-9zM8 9h9v-1h-9v1zM8 11h9v-1h-9v1zM15 16h2v-2h-2v2zM5 16v1h1v-1h-1zM5 18v1h1v-1h-1zM10 16v1h1v-1h-1zM10 18v1h1v-1h-1z"
      }
    })]);
  }
};
export var SvgTemperature = {
  name: 'SvgTemperature',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M7 12v-8c0-0.552 0.448-1 1-1h4c0.552 0 1 0.448 1 1v8c1.214 0.912 2 2.365 2 4 0 2.761-2.239 5-5 5s-5-2.239-5-5c0-1.636 0.786-3.088 2-4zM11.5 5c-0.276 0-0.5 0.224-0.5 0.5v6c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5zM15 6.5c0-0.3 0.2-0.5 0.5-0.5h2c0.3 0 0.5 0.2 0.5 0.5s-0.2 0.5-0.5 0.5h-2c-0.3 0-0.5-0.2-0.5-0.5zM18 8.5c0 0.3-0.2 0.5-0.5 0.5h-2c-0.3 0-0.5-0.2-0.5-0.5s0.2-0.5 0.5-0.5h2c0.3 0 0.5 0.2 0.5 0.5zM18 10.5c0 0.3-0.2 0.5-0.5 0.5h-2c-0.3 0-0.5-0.2-0.5-0.5s0.2-0.5 0.5-0.5h2c0.3 0 0.5 0.2 0.5 0.5z"
      }
    })]);
  }
};
export var SvgTransformer = {
  name: 'SvgTransformer',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M18 18v-11c0-0.5-0.5-1-1-1h-2v-1.5c0-0.3-0.2-0.5-0.5-0.5s-0.5 0.2-0.5 0.5v1.5h-2v-1.5c0-0.3-0.2-0.5-0.5-0.5s-0.5 0.2-0.5 0.5v1.5h-2v-1.5c0-0.3-0.2-0.5-0.5-0.5s-0.5 0.2-0.5 0.5v1.5h-2c-0.5 0-1 0.5-1 1v11h-2v2h17v-2h-2zM8 10h7v3h-7v-3zM9 11h5v1h-5v-1z"
      }
    })]);
  }
};
export var SvgUninterruptiblePowerSupply = {
  name: 'SvgUninterruptiblePowerSupply',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M17.008 21h-10.017c-0.496 0-0.992-0.403-0.992-1.006v-15.987c0-0.604 0.496-1.006 0.992-1.006h10.017c0.496 0 0.992 0.403 0.992 1.006v15.987c0 0.503-0.496 1.006-0.992 1.006zM16 6h-8v1h8v-1zM13.835 8.931l-3.769 4.428 1.884 1.308-2.479 4.428 4.959-5.031-1.884-1.509 1.289-3.623z"
      }
    })]);
  }
};
export var SvgUser = {
  name: 'SvgUser',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M15.826 15.192c1.53 0.708 0.974 0.283 2.226 1.133 1.948 1.275 1.948 3.825 1.948 3.825 0 0.425 0 0.85-0.417 0.85h-14.887c-0.417 0-0.696-0.425-0.696-0.85 0 0 0-2.975 2.087-4.108 1.252-0.708 0.696-0.142 2.365-0.85 1.53-0.708 1.252-0.85 1.252-0.85v-1.558c0 0-0.835-0.425-0.974-1.983-0.417 0-0.557-0.567-0.557-0.992s-0.278-1.417 0.278-1.417c-0.139-0.708-0.139-1.417-0.139-1.842 0.139-1.133 1.391-2.408 3.339-2.55 2.226 0.142 3.2 1.417 3.339 2.692 0 0.425 0 0.992-0.139 1.842 0.557-0.142 0.278 0.992 0.278 1.417s-0.139 0.992-0.557 0.85c-0.139 1.558-0.835 1.983-0.835 1.983v1.558c0 0 0.557 0.142 2.087 0.85z"
      }
    })]);
  }
};
export var SvgUserDefined = {
  name: 'SvgUserDefined',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M18 10.402c-0.255-0.082-0.582-0.132-1-0.146-1.513-0.087-2.299 0.837-2.525 1.715-0.012 0.329-0.058 0.709 0 1.034-0.314 0-0.311 0.477-0.302 0.68s0.041 0.674 0.302 0.611c0.003 0.433 0.236 0.839 0.628 1.093l0.166 0.108c0 0-0.975 0.229-1.796 0.694-1.625 0.919-1.472 2.732-1.472 2.732-0.001 0.026 0 0.051 0.004 0.076h-7.005c-0.552 0-1-0.448-1-1v-12c0-0.552 0.448-1 1-1h12c0.552 0 1 0.448 1 1v4.402zM14.585 10.559v-2.181h-7.385v2.181h0.414c0.111-0.326 0.289-0.675 0.534-1.047s0.472-0.573 0.679-0.602c0.115-0.014 0.256-0.027 0.424-0.038s0.313-0.016 0.435-0.016h0.252v6.032c0 0.132-0.023 0.247-0.070 0.344s-0.14 0.174-0.279 0.231c-0.068 0.029-0.196 0.053-0.384 0.073s-0.334 0.035-0.438 0.046v0.419h4.249v-0.419c-0.122-0.014-0.269-0.038-0.443-0.073s-0.302-0.067-0.384-0.099c-0.136-0.057-0.227-0.135-0.274-0.234s-0.070-0.212-0.070-0.341v-5.978h0.252c0.122 0 0.267 0.005 0.435 0.016s0.31 0.023 0.424 0.038c0.208 0.029 0.434 0.229 0.679 0.602s0.423 0.722 0.534 1.047h0.414zM18.943 16.531c0.399 0.121 0.775 0.304 1.116 0.544 0.589 0.454 0.94 0.942 0.946 1.685 0 0.223-0.004 0.24-0.241 0.24h-7.379c-0.105-0.002-0.384-0.183-0.379-0.447-0.004-0.134 0.014-1.025 1.014-1.596 0.592-0.338 1.827-0.865 1.827-0.865v-0.802c-0.313-0.227-0.5-0.59-0.502-0.976-0.209 0.056-0.272-0.23-0.279-0.411s-0.105-0.697 0.146-0.697c-0.046-0.291-0.065-0.585-0.056-0.879 0.181-0.784 0.883-1.336 1.688-1.325 1.144 0.042 1.59 0.697 1.66 1.304 0.002 0.295-0.023 0.589-0.077 0.879 0.251-0.049 0.146 0.502 0.133 0.697s-0.084 0.467-0.286 0.411c-0.013 0.373-0.168 0.727-0.432 0.99v0.795c0 0 0.314 0.112 1.102 0.453z"
      }
    })]);
  }
};
export var SvgUserDefinedArea = {
  name: 'SvgUserDefinedArea',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M4 5h16c0.552 0 1 0.448 1 1v12c0 0.552-0.448 1-1 1h-16c-0.552 0-1-0.448-1-1v-12c0-0.552 0.448-1 1-1zM4 6v12h16v-12h-16zM5 7h14v10h-14v-10zM9.51 12.034l-1.51-5.034h-1l1.57 5.235-3.57 0.765v1l3.852-0.825 1.148 3.825h1l-1.208-4.027 4.698-1.007 1.51 5.034h1l-1.57-5.235 3.57-0.765v-1l-3.852 0.825-1.148-3.825h-1l1.208 4.027-4.698 1.007z"
      }
    })]);
  }
};
export var SvgUserDefinedEvent = {
  name: 'SvgUserDefinedEvent',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M12.029 21h-6.022c-0.556 0-1.007-0.445-1.007-1.001v-13.998c0-0.553 0.45-1.001 1.007-1.001h1.993v2h8v-2h1.993c0.556 0 1.007 0.445 1.007 1.001v6.813c-0.622-0.604-1.298-0.899-2.029-0.882-0.249 0.006-0.476 0.029-0.682 0.068h-9.289v1h7.669c-0.55 0.817-0.462 1.815-0.515 1.882-0.090 0.113-0.181 0.158-0.136 0.991s0.267 0.821 0.425 1.271c0.106 0.3 0.22 0.421 0.342 0.363 0.118 0-0.288 0.175-1.22 0.524s-1.443 1.339-1.536 2.969zM7 9v1h10v-1h-10zM7 15v1h6v-1h-6zM10 4h4c0.552 0 1 0.448 1 1v1h-6v-1c0-0.552 0.448-1 1-1zM18.906 18.508c0.397 0.12 0.772 0.303 1.111 0.542 0.586 0.452 0.943 0.83 0.949 1.57 0 0.222-0.012 0.347-0.248 0.347 0 0-7.552 0.076-7.623 0s-0.099-0.243-0.095-0.347c0 0-0.012-1.153 1.002-1.688 0.639-0.34 0.396-0.063 1.181-0.41s0.639-0.451 0.639-0.451v-0.799c-0.312-0.226-0.498-0.587-0.5-0.972-0.208 0.056-0.271-0.229-0.278-0.41s-0.104-0.695 0.146-0.695c-0.046-0.289-0.065-0.582-0.056-0.875 0.18-0.781 0.88-1.33 1.681-1.32 1.139 0.042 1.583 0.695 1.653 1.299 0.002 0.293-0.023 0.586-0.076 0.875 0.25-0.049 0.146 0.5 0.132 0.695s-0.083 0.465-0.285 0.41c-0.013 0.371-0.167 0.724-0.431 0.986v0.792c0 0 0.313 0.111 1.097 0.451z"
      }
    })]);
  }
};
export var SvgUserGroup = {
  name: 'SvgUserGroup',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M12.563 13.887c1.237 0.563 0.788 0.225 1.8 0.9 1.575 1.013 1.575 3.038 1.575 3.038 0 0.337 0 0.675-0.337 0.675h-12.038c-0.338 0-0.563-0.337-0.563-0.675 0 0 0-2.363 1.688-3.262 1.012-0.563 0.563-0.112 1.913-0.675 1.237-0.563 1.013-0.675 1.013-0.675v-1.238c0 0-0.675-0.337-0.788-1.575-0.337 0-0.45-0.45-0.45-0.788s-0.225-1.125 0.225-1.125c-0.112-0.562-0.112-1.125-0.112-1.462 0.112-0.9 1.125-1.912 2.7-2.025 1.8 0.113 2.587 1.125 2.7 2.138 0 0.337 0 0.787-0.113 1.462 0.45-0.113 0.225 0.788 0.225 1.125s-0.113 0.788-0.45 0.675c-0.113 1.238-0.675 1.575-0.675 1.575v1.238c0 0 0.45 0.112 1.688 0.675zM21 17.937c0 0.337-0.225 0.563-0.563 0.563h-4.163c0.337-0.112 0.563-0.337 0.563-0.675 0 0 0-2.7-1.912-3.713-0.787-0.45-0.9-0.338-1.237-0.45v-1.125c0 0-0.45-0.337-0.563-1.462-0.225 0.112-0.337-0.338-0.337-0.563s-0.113-1.125 0.225-1.013c-0.112-0.563-0.112-1.012-0.112-1.237 0.112-0.9 0.9-1.8 2.138-1.913 1.463 0.113 2.25 1.012 2.362 1.913 0 0.225 0 0.787-0.113 1.237 0.338-0.112 0.225 0.788 0.225 1.013s-0.112 0.675-0.45 0.563c-0.113 1.125-0.788 1.462-0.788 1.462v1.125c0 0 0.225 0.112 1.462 0.675 1.125 0.563 0.788 0.112 1.688 0.675 1.575 0.675 1.575 2.925 1.575 2.925z"
      }
    })]);
  }
};
export var SvgUvss = {
  name: 'SvgUvss',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M13 7v2.171c1.165 0.412 2 1.523 2 2.829s-0.835 2.417-2 2.829v2.171h2v-1c0-0.552 0.448-1 1-1h1c0.552 0 1 0.448 1 1v4c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1v-2h-6v2c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1v-4c0-0.552 0.448-1 1-1h1c0.552 0 1 0.448 1 1v1h2v-2.171c-1.165-0.412-2-1.523-2-2.829s0.835-2.417 2-2.829v-2.171h-1.54l-0.628 1.725c-0.189 0.519-0.763 0.787-1.282 0.598l-0.94-0.342c-0.519-0.189-0.787-0.763-0.598-1.282l1.368-3.759c0.189-0.519 0.763-0.787 1.282-0.598l0.94 0.342c0.519 0.189 0.787 0.763 0.598 1.282l-0.376 1.034h5.201l0.75-2.060c0.189-0.519 0.763-0.787 1.282-0.598l0.94 0.342c0.519 0.189 0.787 0.763 0.598 1.282l-1.368 3.759c-0.189 0.519-0.763 0.787-1.282 0.598l-0.94-0.342c-0.519-0.189-0.787-0.763-0.598-1.282l0.254-0.698h-1.661zM11 11v2h2v-2h-2z"
      }
    })]);
  }
};
export var SvgView = {
  name: 'SvgView',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M4 5v15h15v-15h-15zM4 4h15c0.552 0 1 0.448 1 1v15c0 0.552-0.448 1-1 1h-15c-0.552 0-1-0.448-1-1v-15c0-0.552 0.448-1 1-1zM5 19v-13h6v13h-6zM12 19v-6h6v6h-6zM12 12v-6h6v6h-6z"
      }
    })]);
  }
};
export var SvgWaterLevel = {
  name: 'SvgWaterLevel',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M16.533 11.826c-0.51 0.116-1.021 0.174-1.533 0.174-1.031 0-1.864-0.485-3.017-1.539-0.097-0.089-0.197-0.182-0.32-0.298-0.061-0.057-0.159-0.15-0.317-0.299-1.16-1.092-1.911-1.633-2.728-1.803-0.888 1.24-1.551 2.362-1.987 3.365 0.569-0.526 1.335-0.927 2.369-0.927 2.5 0 3 3.5 5 3.5 1.302 0 2.227-0.377 2.775-1.456-0.066-0.232-0.147-0.471-0.242-0.718zM16.121 10.891c-0.88-1.785-2.42-3.916-4.621-6.391-0.843 0.949-1.59 1.847-2.239 2.694 0.856 0.285 1.663 0.9 2.77 1.942 0.16 0.151 0.257 0.242 0.317 0.299 0.12 0.113 0.217 0.203 0.31 0.288 0.982 0.898 1.634 1.277 2.343 1.277 0.373 0 0.746-0.036 1.121-0.109zM7.452 8.019c-1.571 0.109-2.743 0.703-3.552 1.781-0.166 0.221-0.479 0.266-0.7 0.1s-0.266-0.479-0.1-0.7c1.1-1.467 2.75-2.2 4.9-2.2 0.058 0 0.116 0.001 0.173 0.003 0.912-1.235 2.021-2.57 3.327-4.003 2.702 2.965 4.561 5.507 5.578 7.625 0.864-0.31 1.733-0.815 2.609-1.516 0.216-0.173 0.53-0.138 0.703 0.078s0.138 0.53-0.078 0.703c-0.939 0.751-1.884 1.303-2.835 1.654 0.349 0.906 0.523 1.725 0.523 2.456 0 3.866-2.634 7-6.5 7s-6.5-3.134-6.5-7c0-1.583 0.817-3.577 2.452-5.981z"
      }
    })]);
  }
};
export var SvgWindSpeed = {
  name: 'SvgWindSpeed',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M17.075 7.979c0.188-0.603 0.712-0.979 1.425-0.979 0.9 0 1.5 0.6 1.5 1.5s-0.6 1.5-1.5 1.5c-0.721 0-1.25-0.385-1.431-1.001-0.022 0.001-0.045 0.001-0.069 0.001l-4-0.4v1.4l3 1v9c0 0.1 0 0.1 0 0.1 0 0.5-2.3 0.9-4 0.9s-4-0.4-4-0.9c0-0.1 0-0.1 0-0.1v-9l3-1v-0.8l-4 0.6c0 0-0.006-0.014-0.017-0.043-0.104 0.755-0.671 1.243-1.483 1.243-0.9 0-1.5-0.6-1.5-1.5s0.6-1.5 1.5-1.5c0.625 0 1.105 0.289 1.34 0.767l4.16-0.567v-1.1h0.3l-0.645-1.106c-0.051 0.004-0.102 0.006-0.155 0.006-0.9 0-1.5-0.6-1.5-1.5s0.6-1.5 1.5-1.5c0.9 0 1.5 0.6 1.5 1.5 0 0.442-0.145 0.811-0.398 1.073l0.898 1.527h0.5v0.5l4.075 0.379z"
      }
    })]);
  }
};
export var SvgZone = {
  name: 'SvgZone',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M20 5.5v14c0 0.276-0.224 0.5-0.5 0.5h-15c-0.276 0-0.5-0.224-0.5-0.5v-14c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v1.5h2v-1.5c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v1.5h2v-1.5c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5zM10 12v-1h-3v1h3zM14 11h-2v1h2v-1zM19 11h-3v1h3v-1zM12 8h-2v1h2v-1zM17 8h-3v1h3v-1zM10 17h-3v1h3v-1zM14 17h-2v1h2v-1zM19 17h-3v1h3v-1zM12 14h-2v1h2v-1zM17 14h-3v1h3v-1zM5 8v1h3v-1h-3zM5 14v1h3v-1h-3z"
      }
    })]);
  }
};
export var SvgStateAlarm = {
  name: 'SvgStateAlarm',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "attrs": {
        "strokePath": "true",
        "fill": "#fff",
        "d": "M6.5 1c1.952 0 3.5 1.548 3.5 3.5v6.5c0 1.105-0.895 2-2 2h-7v-8.5c0-1.952 1.548-3.5 3.5-3.5h2z"
      }
    }), h("path", {
      "style": pathStyle,
      "attrs": {
        "fill": "#fa3239",
        "d": "M6.5 2c1.4 0 2.5 1.1 2.5 2.5v4.5h-7v-4.5c0-1.4 1.1-2.5 2.5-2.5h2zM2 12v-2h7v1c0 0.552-0.448 1-1 1h-6zM3 5v3h1v-3h-1z"
      }
    })]);
  }
};
export var SvgStateCascade = {
  name: 'SvgStateCascade',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "attrs": {
        "strokePath": "true",
        "fill": "#fff",
        "d": "M20 7v4h-4v-4h-1.826c-0.552 0-1-0.448-1-1 0-0.239 0.085-0.47 0.241-0.651l3.826-4.463c0.359-0.419 0.991-0.468 1.41-0.108 0.039 0.033 0.075 0.070 0.108 0.108l3.826 4.463c0.359 0.419 0.311 1.051-0.108 1.41-0.181 0.155-0.412 0.241-0.651 0.241h-1.826z"
      }
    }), h("path", {
      "style": pathStyle,
      "attrs": {
        "fill": "#2196f3",
        "d": "M19 6v4h-2v-4h-1.398c-0.276 0-0.5-0.224-0.5-0.5 0-0.121 0.044-0.238 0.124-0.329l2.398-2.741c0.182-0.208 0.498-0.229 0.706-0.047 0.017 0.015 0.032 0.030 0.047 0.047l2.398 2.741c0.182 0.208 0.161 0.524-0.047 0.706-0.091 0.080-0.208 0.124-0.329 0.124h-1.398z"
      }
    })]);
  }
};
export var SvgStateDisable = {
  name: 'SvgStateDisable',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "width": "24px",
        "height": "24px",
        "viewBox": "0 0 24 24",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [h("g", {
      "attrs": {
        "id": "State",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [h("g", {
      "attrs": {
        "id": "Tree/State/Disable",
        "fill-rule": "nonzero"
      }
    }, [h("path", {
      "attrs": {
        "d": "M18.5,23 C16.0147186,23 14,20.9852814 14,18.5 C14,16.0147186 16.0147186,14 18.5,14 C20.9852814,14 23,16.0147186 23,18.5 C23,20.9852814 20.9852814,23 18.5,23 Z",
        "id": "路径",
        "fill": "#FFFFFF"
      }
    }), h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M16.4141983,17.1213051 C16.1524384,17.5165216 16,17.9904588 16,18.5 C16,19.8807119 17.1192881,21 18.5,21 C19.0095412,21 19.4834784,20.8475616 19.8786949,20.5858017 L16.4141983,17.1213051 L16.4141983,17.1213051 Z M17.1213051,16.4141983 L20.5858017,19.8786949 C20.8475616,19.4834784 21,19.0095412 21,18.5 C21,17.1192881 19.8807119,16 18.5,16 C17.9904588,16 17.5165216,16.1524384 17.1213051,16.4141983 L17.1213051,16.4141983 Z M18.5,22 C16.5670034,22 15,20.4329966 15,18.5 C15,16.5670034 16.5670034,15 18.5,15 C20.4329966,15 22,16.5670034 22,18.5 C22,20.4329966 20.4329966,22 18.5,22 Z",
        "id": "形状",
        "fill": "#FA3239"
      }
    })])])]);
  }
};
export var SvgStateException = {
  name: 'SvgStateException',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "attrs": {
        "strokePath": "true",
        "fill": "#fff",
        "d": "M6 12c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
      }
    }), h("path", {
      "style": pathStyle,
      "attrs": {
        "fill": "#28bdf1",
        "d": "M6 11c-2.761 0-5-2.239-5-5s2.239-5 5-5c2.761 0 5 2.239 5 5s-2.239 5-5 5zM6.093 2.198c-0.705 0-1.276 0.224-1.695 0.674-0.398 0.429-0.598 0.995-0.598 1.682v0.25h1.22v-0.25c0-0.385 0.082-0.677 0.238-0.885 0.173-0.228 0.43-0.341 0.799-0.341 0.322 0 0.553 0.080 0.714 0.242 0.147 0.147 0.224 0.363 0.224 0.66 0 0.19-0.068 0.372-0.21 0.56-0.064 0.072-0.162 0.176-0.284 0.298-0.515 0.457-0.829 0.815-0.962 1.121-0.127 0.243-0.192 0.542-0.192 0.882v0.457h1.229v-0.457c0-0.205 0.045-0.385 0.136-0.539 0.080-0.144 0.198-0.283 0.361-0.423 0.43-0.381 0.669-0.605 0.767-0.723 0.261-0.359 0.391-0.763 0.391-1.213 0-0.604-0.196-1.096-0.585-1.453-0.384-0.364-0.91-0.543-1.555-0.543zM5.967 8.25c-0.233 0-0.424 0.074-0.571 0.234-0.145 0.132-0.228 0.325-0.228 0.547 0 0.219 0.080 0.408 0.235 0.564 0.149 0.149 0.34 0.226 0.564 0.226 0.207 0 0.402-0.077 0.556-0.219 0.157-0.157 0.234-0.348 0.234-0.571 0-0.216-0.078-0.407-0.226-0.555-0.154-0.154-0.342-0.226-0.564-0.226z"
      }
    })]);
  }
};
export var SvgStateLink = {
  name: 'SvgStateLink',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "attrs": {
        "strokePath": "true",
        "fill": "#fff",
        "d": "M4 16h7c1.657 0 3 1.343 3 3v1c0 1.657-1.343 3-3 3h-7c-1.657 0-3-1.343-3-3v-1c0-1.657 1.343-3 3-3z"
      }
    }), h("path", {
      "style": pathStyle,
      "attrs": {
        "fill": "#2196f3",
        "d": "M8 22h-4c-1.105 0-2-0.895-2-2v-1c0-1.105 0.895-2 2-2h2v2h1v-2h4c1.105 0 2 0.895 2 2v1c0 1.105-0.895 2-2 2h-2v-2h-1v2zM4.5 19c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h6c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-6z"
      }
    })]);
  }
};
export var SvgStateNoLongitudeAndLatitude = {
  name: 'SvgStateNoLongitudeAndLatitude',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "width": "24px",
        "height": "24px",
        "viewBox": "0 0 24 24",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [h("g", {
      "attrs": {
        "id": "State",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [h("g", {
      "attrs": {
        "id": "Tree/State/No_longitude_and_latitude",
        "fill-rule": "nonzero"
      }
    }, [h("path", {
      "attrs": {
        "d": "M5.5,23 C8.5,20.3235209 10,18.1568542 10,16.5 C10,14.0147186 7.98528137,12 5.5,12 C3.01471863,12 1,14.0147186 1,16.5 C1,18.1568542 2.5,20.3235209 5.5,23 Z",
        "id": "椭圆形",
        "fill": "#FFFFFF"
      }
    }), h("path", {
      "style": pathStyle,
      "attrs": {
        "d": "M6.87869495,18.5858017 L3.41419827,15.1213051 C3.15243838,15.5165216 3,15.9904588 3,16.5 C3,17.8807119 4.11928813,19 5.5,19 C6.00954117,19 6.48347844,18.8475616 6.87869495,18.5858017 L6.87869495,18.5858017 Z M7.58580173,17.8786949 C7.84756162,17.4834784 8,17.0095412 8,16.5 C8,15.1192881 6.88071187,14 5.5,14 C4.99045883,14 4.51652156,14.1524384 4.12130505,14.4141983 L7.58580173,17.8786949 Z M5.5,22 C3.16666667,19.6219977 2,17.7886644 2,16.5 C2,14.5670034 3.56700338,13 5.5,13 C7.43299662,13 9,14.5670034 9,16.5 C9,17.7886644 7.83333333,19.6219977 5.5,22 Z",
        "id": "形状",
        "fill": "#FA3239"
      }
    })])])]);
  }
};
export var SvgStateOffline = {
  name: 'SvgStateOffline',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "attrs": {
        "strokePath": "true",
        "fill": "#fff",
        "d": "M6 12c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
      }
    }), h("path", {
      "style": pathStyle,
      "attrs": {
        "fill": "#fa3239",
        "d": "M6 11c-2.761 0-5-2.239-5-5s2.239-5 5-5c2.761 0 5 2.239 5 5s-2.239 5-5 5zM3 6.75h6v-1.5h-6v1.5z"
      }
    })]);
  }
};
export var SvgStatePlay = {
  name: 'SvgStatePlay',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "attrs": {
        "strokePath": "true",
        "fill": "#fff",
        "d": "M17.295 22.773c-0.999 0.624-2.295-0.094-2.295-1.272v-7c0-1.178 1.296-1.896 2.338-1.243l4.957 3.471c0.931 0.582 0.94 1.93 0.027 2.527l-5.027 3.517z"
      }
    }), h("path", {
      "style": pathStyle,
      "attrs": {
        "fill": "#02bf0f",
        "d": "M21.765 18.425c0.313-0.196 0.313-0.652 0-0.848l-5-3.5c-0.333-0.208-0.765 0.031-0.765 0.424v7c0 0.393 0.432 0.632 0.765 0.424l5-3.5z"
      }
    })]);
  }
};
export var SvgStateRecording = {
  name: 'SvgStateRecording',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "attrs": {
        "strokePath": "true",
        "fill": "#fff",
        "d": "M22 19c0 2.209-1.791 4-4 4s-4-1.791-4-4c0-2.209 1.791-4 4-4s4 1.791 4 4z"
      }
    }), h("path", {
      "style": pathStyle,
      "attrs": {
        "fill": "#fa3239",
        "d": "M21 19c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"
      }
    })]);
  }
};
export var SvgStateUnknow = {
  name: 'SvgStateUnknow',
  props: {
    size: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    }
  },
  functional: true,

  /* eslint-disable-next-line */
  render: function render(h, ctx) {
    var style = {
      'font-size': ctx.props.size ? ctx.props.size + 'px' : null
    };
    var pathStyle = {
      'fill': ctx.props.color || null
    };
    return h("svg", {
      "class": "h-svg-icon__main",
      "style": style,
      "attrs": {
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [h("path", {
      "attrs": {
        "strokePath": "true",
        "fill": "#fff",
        "d": "M6 12c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
      }
    }), h("path", {
      "style": pathStyle,
      "attrs": {
        "fill": "#ff952c",
        "d": "M6 11c-2.761 0-5-2.239-5-5s2.239-5 5-5c2.761 0 5 2.239 5 5s-2.239 5-5 5zM5.25 3v4h1.5v-4h-1.5zM5.25 8.25v1.5h1.5v-1.5h-1.5z"
      }
    })]);
  }
};
export default [SvgAccessControl, SvgAccessControlDevice, SvgAccessLevel, SvgAirConditioner, SvgAlarm, SvgAlarmBox, SvgAlarmInput, SvgAlarmOutput, SvgAlarmSmallBox, SvgArea, SvgBooth, SvgBoxCamera, SvgBoxCameraWithPtz, SvgBranch, SvgCamera, SvgCameraProbe, SvgCardReader, SvgCenter, SvgChildParkingLot, SvgCity, SvgCommandCenter, SvgDepartment, SvgDevice, SvgDistrict, SvgDomeCamera, SvgDoorStation, SvgDoorStationWall, SvgDriver, SvgElevatorControl, SvgElevatorControlDevice, SvgEntranceAndExit, SvgEnviromentalVariable, SvgEvent, SvgFaceAndIdComparison, SvgFactory, SvgFieldOfView, SvgFloor, SvgGateway, SvgGisMap, SvgGroup, SvgHeadquarter, SvgHeadset, SvgIntelligentLock, SvgLabel, SvgLane, SvgLicense, SvgLocation, SvgMap, SvgMapLink, SvgMapMarking, SvgMicrophone, SvgMiddleLargeSizeVehicle, SvgMonitoringPoint, SvgMonitoringPointOfWidthAndHeight, SvgMotorcade, SvgNoise, SvgOrganization, SvgOverloadControlAtFixedLocation, SvgOverloadControlByTechnology, SvgOverloadControlFromSource, SvgPanovuCamera, SvgParkingLot, SvgPartition, SvgPeopleDensityDetectionCamera, SvgPoisonousGas, SvgPolePanicAlarmStation, SvgPortableDvr, SvgPosTerminal, SvgPower, SvgPreset, SvgPrison, SvgProvince, SvgRemoteSite, SvgSecurityControlPanel, SvgSensor, SvgServer, SvgSite, SvgSmartLinkageSystem, SvgSmartLinkageSystemProbe, SvgSpeedDome, SvgStorageServer, SvgStreamingServer, SvgTemperature, SvgTransformer, SvgUninterruptiblePowerSupply, SvgUser, SvgUserDefined, SvgUserDefinedArea, SvgUserDefinedEvent, SvgUserGroup, SvgUvss, SvgView, SvgWaterLevel, SvgWindSpeed, SvgZone, SvgStateAlarm, SvgStateCascade, SvgStateDisable, SvgStateException, SvgStateLink, SvgStateNoLongitudeAndLatitude, SvgStateOffline, SvgStatePlay, SvgStateRecording, SvgStateUnknow];